// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3, DiskUsageLimitsWireFormat3 as KaggleSdkCommonDiskUsageLimitsWireFormat3, PageMessageWireFormat3 as KaggleSdkCommonPageMessageWireFormat3 } from "../common";
import { CompetitionWireFormat3 as KaggleSdkCompetitionsCompetitionWireFormat3 } from "../competitions";
import { DatasetForReviewWireFormat3 as KaggleSdkDatasetsDatasetForReviewWireFormat3, DatasetListItemWireFormat3 as KaggleSdkDatasetsDatasetListItemWireFormat3 } from "../datasets";
import { CommentAttachmentWireFormat3 as KaggleSdkDiscussionsCommentAttachmentWireFormat3, CommentVoteButtonWireFormat3 as KaggleSdkDiscussionsCommentVoteButtonWireFormat3, DiscussionItemLinkWireFormat3 as KaggleSdkDiscussionsDiscussionItemLinkWireFormat3, TopicListItemWireFormat3 as KaggleSdkDiscussionsTopicListItemWireFormat3 } from "../discussions";
import { LearnTrackWireFormat3 as KaggleSdkEducationLearnTrackWireFormat3 } from "../education";
import { KernelListItemWireFormat3 as KaggleSdkKernelsKernelListItemWireFormat3 } from "../kernels";
import { ModelWireFormat3 as KaggleSdkModelsModelWireFormat3 } from "../models";
import { DiscordConfigWireFormat3 as KaggleSdkUsersDiscordDiscordConfigWireFormat3 } from "./discord";
export var AcceptCookiesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAccountDto = {
    userId: 0,
    userName: "",
    emailAddress: "",
    verifyAccountUrl: "",
    isSmsVerified: false,
    isSubscribedToMailingList: false,
    logins: [],
    canSeeApi: false
};
export var AccountDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAccountDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logins) {
            message.logins = wireFormat.logins.map(function(i) {
                return UserLoginDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetLimits) {
            message.datasetLimits = KaggleSdkCommonDiskUsageLimitsWireFormat3.fromJson(wireFormat.datasetLimits);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelLimits) {
            message.modelLimits = KaggleSdkCommonDiskUsageLimitsWireFormat3.fromJson(wireFormat.modelLimits);
        }
        return message;
    }
};
var defaultAchievementSummary = {
    totalResults: 0,
    rankOutOf: 0,
    totalGoldMedals: 0,
    totalSilverMedals: 0,
    totalBronzeMedals: 0
};
export var AchievementSummaryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAchievementSummary, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        if (wireFormat) {
            message.summaryType = UserAchievementTypeWireFormat3.fromJson(wireFormat.summaryType);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rankPercentage) != undefined) {
            message.rankPercentage = Number(wireFormat.rankPercentage);
        }
        return message;
    }
};
var defaultAchievementSummaryDto = {
    totalResults: 0,
    rankPercentage: 0,
    rankOutOf: 0,
    totalGoldMedals: 0,
    totalSilverMedals: 0,
    totalBronzeMedals: 0,
    highlights: []
};
export var AchievementSummaryDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAchievementSummaryDto, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rankPercentage) != undefined) {
            message.rankPercentage = Number(wireFormat.rankPercentage);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.highlights) {
            message.highlights = wireFormat.highlights.map(function(i) {
                return AchievementSummaryHighlightDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.summaryType = AchievementSummaryTypeWireFormat3.fromJson(wireFormat.summaryType);
        }
        return message;
    }
};
var defaultAchievementSummaryHighlightDto = {
    score: 0,
    scoreOutOf: 0,
    isOngoingCompetition: false
};
export var AchievementSummaryHighlightDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAchievementSummaryHighlightDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        if (wireFormat) {
            message.medal = MedalWireFormat3.fromJson(wireFormat.medal);
        }
        return message;
    }
};
var defaultAchievementTypeRanking = {
    ranking: 0
};
export var AchievementTypeRankingWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAchievementTypeRanking, wireFormat);
        if (wireFormat) {
            message.type = UserAchievementTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
export var ActivateAccountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultActivityCalendar = {
    totalSubmissionsCount: 0,
    totalScriptsCount: 0,
    totalDiscussionsCount: 0,
    totalDatasetsCount: 0
};
export var ActivityCalendarWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityCalendar, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        return message;
    }
};
export var AddNudgeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAddNudgeResponse = {
    nudgeId: 0
};
export var AddNudgeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddNudgeResponse, wireFormat);
        return message;
    }
};
export var AddSuggestedItemRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAddSuggestedItemResponse = {
    id: 0
};
export var AddSuggestedItemResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddSuggestedItemResponse, wireFormat);
        return message;
    }
};
export var AttributeValueWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.attributeId) {
            wireFormat.attributeId = AttributeIdWireFormat3.toJson(message.attributeId);
        }
        return wireFormat;
    }
};
var defaultBookmark = {
    bookmarkedEntityId: 0
};
export var BookmarkWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBookmark, wireFormat);
        if (wireFormat) {
            message.bookmarkType = BookmarkTypeWireFormat3.fromJson(wireFormat.bookmarkType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bookmarkedDate) {
            message.bookmarkedDate = new Date(wireFormat.bookmarkedDate);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bookmarkType) {
            wireFormat.bookmarkType = BookmarkTypeWireFormat3.toJson(message.bookmarkType);
        }
        if (message === null || message === void 0 ? void 0 : message.bookmarkedDate) {
            wireFormat.bookmarkedDate = message.bookmarkedDate.toISOString();
        }
        return wireFormat;
    }
};
export var BulkSetKaggleXRoleRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.role) {
            wireFormat.role = KaggleXRoleWireFormat3.toJson(message.role);
        }
        return wireFormat;
    }
};
export var BulkVerifyPhoneRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CheckCustomNudgeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCheckCustomNudgeResponse = {};
export var CheckCustomNudgeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCheckCustomNudgeResponse, wireFormat);
        if (wireFormat) {
            message.checkResult = CheckResultWireFormat3.fromJson(wireFormat.checkResult);
        }
        return message;
    }
};
export var CheckForNudgeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCheckForNudgeResponse = {
    potentialNudges: []
};
export var CheckForNudgeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCheckForNudgeResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.potentialNudges) {
            message.potentialNudges = wireFormat.potentialNudges.map(function(i) {
                return PotentialNudgeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultCollaborator = {
    profileUrl: "",
    thumbnailUrl: "",
    name: "",
    slug: ""
};
export var CollaboratorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCollaborator, wireFormat);
        if (wireFormat) {
            message.userTier = UserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.joinDate) {
            message.joinDate = new Date(wireFormat.joinDate);
        }
        if (wireFormat) {
            message.type = CollaboratorTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.userTier) {
            wireFormat.userTier = UserAchievementTierWireFormat3.toJson(message.userTier);
        }
        if (message === null || message === void 0 ? void 0 : message.joinDate) {
            wireFormat.joinDate = message.joinDate.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = CollaboratorTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
var defaultCollaboratorList = {
    collaborators: []
};
export var CollaboratorListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCollaboratorList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = CollaboratorWireFormat3.fromJson(wireFormat.owner);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
            message.collaborators = wireFormat.collaborators.map(function(i) {
                return CollaboratorWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.owner) {
            wireFormat.owner = CollaboratorWireFormat3.toJson(message.owner);
        }
        if (message === null || message === void 0 ? void 0 : message.collaborators) {
            wireFormat.collaborators = message.collaborators.map(function(i) {
                return CollaboratorWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultContactPageDto = {
    forgotPasswordLink: "",
    competitionsLink: "",
    datasetsLink: "",
    newDatasetLink: "",
    datasetsForumLink: "",
    hostLink: "",
    communityCompetitionsOverviewLink: "",
    migrateDeprecatedSsoLink: "",
    complianceLink: ""
};
export var ContactPageDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultContactPageDto, wireFormat);
        return message;
    }
};
export var ContactSupportRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = ContactSupportTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
export var ConvertLegacyFavoritesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bookmarkType) {
            wireFormat.bookmarkType = BookmarkTypeWireFormat3.toJson(message.bookmarkType);
        }
        if (message === null || message === void 0 ? void 0 : message.conversionMethod) {
            wireFormat.conversionMethod = ConversionMethodWireFormat3.toJson(message.conversionMethod);
        }
        return wireFormat;
    }
};
var defaultConvertLegacyFavoritesResponse = {};
export var ConvertLegacyFavoritesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultConvertLegacyFavoritesResponse, wireFormat);
        return message;
    }
};
export var CreateBookmarkRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bookmark) {
            wireFormat.bookmark = BookmarkWireFormat3.toJson(message.bookmark);
        }
        return wireFormat;
    }
};
var defaultCreateBookmarkResponse = {};
export var CreateBookmarkResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateBookmarkResponse, wireFormat);
        return message;
    }
};
export var CreateKaggleAccountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateUserMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateUserMessageResponse = {};
export var CreateUserMessageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateUserMessageResponse, wireFormat);
        return message;
    }
};
export var CreateWorkspaceItemsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.items) {
            wireFormat.items = message.items.map(function(i) {
                return WorkspaceItemWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var CreateWorkspaceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateWorkspaceResponse = {
    workspaceId: 0
};
export var CreateWorkspaceResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateWorkspaceResponse, wireFormat);
        return message;
    }
};
var defaultCreationCounts = {
    totalCount: 0,
    lastMonthCount: 0
};
export var CreationCountsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreationCounts, wireFormat);
        return message;
    }
};
var defaultCurrentUserPenalty = {
    id: 0,
    policyViolationDescriptions: []
};
export var CurrentUserPenaltyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCurrentUserPenalty, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logTime) {
            message.logTime = new Date(wireFormat.logTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.suspensionLiftTime) {
            message.suspensionLiftTime = new Date(wireFormat.suspensionLiftTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.appealApprovalTime) {
            message.appealApprovalTime = new Date(wireFormat.appealApprovalTime);
        }
        return message;
    }
};
export var DeleteBookmarkRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bookmark) {
            wireFormat.bookmark = BookmarkWireFormat3.toJson(message.bookmark);
        }
        return wireFormat;
    }
};
var defaultDeleteBookmarkResponse = {};
export var DeleteBookmarkResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteBookmarkResponse, wireFormat);
        return message;
    }
};
export var DeleteCurrentAccountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteDiscordInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeletePhoneVerificationsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteWorkspaceItemsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteWorkspaceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDiscordConfigValue = {
    value: ""
};
export var DiscordConfigValueWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscordConfigValue, wireFormat);
        if (wireFormat) {
            message.name = KaggleSdkUsersDiscordDiscordConfigWireFormat3.fromJson(wireFormat.name);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.name) {
            wireFormat.name = KaggleSdkUsersDiscordDiscordConfigWireFormat3.toJson(message.name);
        }
        return wireFormat;
    }
};
var defaultDiscordUserInfo = {
    userId: 0,
    login: "",
    avatarUrl: ""
};
export var DiscordUserInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscordUserInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userId) {
            message.userId = parseInt(wireFormat.userId);
        }
        return message;
    }
};
var defaultDiscussionCounts = {
    totalDiscussionsCount: 0,
    totalTopicsCount: 0,
    totalRepliesCount: 0,
    totalUpvotesCount: 0
};
export var DiscussionCountsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionCounts, wireFormat);
        return message;
    }
};
var defaultDiscussionItem = {
    id: 0,
    totalScore: 0,
    message: "",
    rawMarkdown: "",
    attachments: []
};
export var DiscussionItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionItem, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.postTime) {
            message.postTime = new Date(wireFormat.postTime);
        }
        if (wireFormat) {
            message.medal = MedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.attachments) {
            message.attachments = wireFormat.attachments.map(function(i) {
                return KaggleSdkDiscussionsCommentAttachmentWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.type = DiscussionTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.script) {
            message.script = KaggleSdkDiscussionsDiscussionItemLinkWireFormat3.fromJson(wireFormat.script);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forum) {
            message.forum = KaggleSdkDiscussionsDiscussionItemLinkWireFormat3.fromJson(wireFormat.forum);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forumTopic) {
            message.forumTopic = KaggleSdkDiscussionsDiscussionItemLinkWireFormat3.fromJson(wireFormat.forumTopic);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.vote) {
            message.vote = KaggleSdkDiscussionsCommentVoteButtonWireFormat3.fromJson(wireFormat.vote);
        }
        return message;
    }
};
export var DismissHatsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.location) {
            wireFormat.location = HatsLocationWireFormat3.toJson(message.location);
        }
        return wireFormat;
    }
};
var defaultDismissHatsResponse = {};
export var DismissHatsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDismissHatsResponse, wireFormat);
        return message;
    }
};
export var DismissSuggestedItemRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DismissSurveyRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.location) {
            wireFormat.location = HatsLocationWireFormat3.toJson(message.location);
        }
        if (message === null || message === void 0 ? void 0 : message.surveyType) {
            wireFormat.surveyType = SurveyTypeWireFormat3.toJson(message.surveyType);
        }
        return wireFormat;
    }
};
var defaultDismissSurveyResponse = {};
export var DismissSurveyResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDismissSurveyResponse, wireFormat);
        return message;
    }
};
export var EmailSignInRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultEmailSignInResponse = {
    redirectUrl: ""
};
export var EmailSignInResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEmailSignInResponse, wireFormat);
        return message;
    }
};
var defaultEntityCountData = {
    competitionCount: 0,
    competitionSolutionCount: 0,
    datasetCount: 0,
    kernelCount: 0,
    learnTotalHours: 0,
    modelCount: 0,
    userCount: 0
};
export var EntityCountDataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEntityCountData, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionCount) {
            message.competitionCount = parseInt(wireFormat.competitionCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetCount) {
            message.datasetCount = parseInt(wireFormat.datasetCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelCount) {
            message.kernelCount = parseInt(wireFormat.kernelCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelCount) {
            message.modelCount = parseInt(wireFormat.modelCount);
        }
        return message;
    }
};
var defaultEntityListingData = {
    competitions: [],
    competitionSolutions: [],
    datasets: [],
    kernels: [],
    models: [],
    learnCourses: []
};
export var EntityListingDataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEntityListingData, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitions) {
            message.competitions = wireFormat.competitions.map(function(i) {
                return KaggleSdkCompetitionsCompetitionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionSolutions) {
            message.competitionSolutions = wireFormat.competitionSolutions.map(function(i) {
                return KaggleSdkDiscussionsTopicListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
            message.datasets = wireFormat.datasets.map(function(i) {
                return KaggleSdkDatasetsDatasetListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernels) {
            message.kernels = wireFormat.kernels.map(function(i) {
                return KaggleSdkKernelsKernelListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.models) {
            message.models = wireFormat.models.map(function(i) {
                return KaggleSdkModelsModelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnCourses) {
            message.learnCourses = wireFormat.learnCourses.map(function(i) {
                return KaggleSdkEducationLearnTrackWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ExpireApiTokensRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultFollower = {
    userId: 0,
    userName: "",
    displayName: "",
    thumbnailUrl: ""
};
export var FollowerWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFollower, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultFollowersItemDto = {
    userId: 0
};
export var FollowersItemDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFollowersItemDto, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultFollowersListDto = {
    count: 0,
    list: [],
    containsSelf: false,
    maxCountReached: false
};
export var FollowersListDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFollowersListDto, wireFormat);
        if (wireFormat) {
            message.type = FollowersListTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.list) {
            message.list = wireFormat.list.map(function(i) {
                return FollowersItemDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var FollowUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultFollowUserResponse = {};
export var FollowUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFollowUserResponse, wireFormat);
        return message;
    }
};
export var GenerateAnalyticsTokenRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGenerateAnalyticsTokenResponse = {
    token: ""
};
export var GenerateAnalyticsTokenResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGenerateAnalyticsTokenResponse, wireFormat);
        return message;
    }
};
export var GenerateApiTokenRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGenerateApiTokenResponse = {
    userName: "",
    apiToken: ""
};
export var GenerateApiTokenResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGenerateApiTokenResponse, wireFormat);
        return message;
    }
};
export var GetBookmarkMigrationStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bookmarkType) {
            wireFormat.bookmarkType = BookmarkTypeWireFormat3.toJson(message.bookmarkType);
        }
        return wireFormat;
    }
};
var defaultGetBookmarkMigrationStatusResponse = {
    remainingCount: 0
};
export var GetBookmarkMigrationStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetBookmarkMigrationStatusResponse, wireFormat);
        return message;
    }
};
export var GetBuildInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetBuildInfoResponse = {
    isDebug: false,
    machineName: "",
    buildHash: "",
    commitUrl: "",
    buildTimeAgo: ""
};
export var GetBuildInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetBuildInfoResponse, wireFormat);
        return message;
    }
};
export var GetCaptchaConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCaptchaConfigResponse = {
    siteKey: "",
    enabled: false
};
export var GetCaptchaConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCaptchaConfigResponse, wireFormat);
        return message;
    }
};
export var GetContactUserInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetContactUserInfoResponse = {
    canSend: false,
    emailsRemaining: 0
};
export var GetContactUserInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetContactUserInfoResponse, wireFormat);
        if (wireFormat) {
            message.error = ContactUserInfoErrorWireFormat3.fromJson(wireFormat.error);
        }
        return message;
    }
};
export var GetCurrentUserIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCurrentUserIdResponse = {};
export var GetCurrentUserIdResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCurrentUserIdResponse, wireFormat);
        return message;
    }
};
export var GetCurrentUserProgressionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCurrentUserProgressionResponse = {
    tierRequirementGroups: [],
    achievementTypeRankings: []
};
export var GetCurrentUserProgressionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCurrentUserProgressionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tierRequirementGroups) {
            message.tierRequirementGroups = wireFormat.tierRequirementGroups.map(function(i) {
                return TierRequirementGroupWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.achievementTypeRankings) {
            message.achievementTypeRankings = wireFormat.achievementTypeRankings.map(function(i) {
                return AchievementTypeRankingWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetCurrentUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDiscordInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDiscordInfoResponse = {
    secretId: 0
};
export var GetDiscordInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDiscordInfoResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userInfo) {
            message.userInfo = DiscordUserInfoWireFormat3.fromJson(wireFormat.userInfo);
        }
        return message;
    }
};
export var GetHomepageStatsDismissedStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetHomepageStatsDismissedStatusResponse = {};
export var GetHomepageStatsDismissedStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetHomepageStatsDismissedStatusResponse, wireFormat);
        if (wireFormat) {
            message.state = HomepageStatsDismissedStateWireFormat3.fromJson(wireFormat.state);
        }
        return message;
    }
};
export var GetHomePageStatsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetHomePageStatsResponse = {
    maxDayStreak: 0,
    currentDayStreak: 0
};
export var GetHomePageStatsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetHomePageStatsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
            message.datasets = CreationCountsWireFormat3.fromJson(wireFormat.datasets);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notebooks) {
            message.notebooks = CreationCountsWireFormat3.fromJson(wireFormat.notebooks);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussions) {
            message.discussions = CreationCountsWireFormat3.fromJson(wireFormat.discussions);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitions) {
            message.competitions = CreationCountsWireFormat3.fromJson(wireFormat.competitions);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.courses) {
            message.courses = CreationCountsWireFormat3.fromJson(wireFormat.courses);
        }
        return message;
    }
};
export var GetLoggedOutHomepageDataRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetLoggedOutHomepageDataResponse = {};
export var GetLoggedOutHomepageDataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetLoggedOutHomepageDataResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.countData) {
            message.countData = EntityCountDataWireFormat3.fromJson(wireFormat.countData);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.listingData) {
            message.listingData = EntityListingDataWireFormat3.fromJson(wireFormat.listingData);
        }
        return message;
    }
};
export var GetMyAttributesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.attributes) {
            wireFormat.attributes = message.attributes.map(function(i) {
                return AttributeIdWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultGetMyAttributesResponse = {
    attributes: []
};
export var GetMyAttributesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetMyAttributesResponse, wireFormat);
        return message;
    }
};
export var GetNewPasswordRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetNewPasswordResponse = {
    newPassword: ""
};
export var GetNewPasswordResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetNewPasswordResponse, wireFormat);
        return message;
    }
};
export var GetNextStepsConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetNextStepsConfigResponse = {
    suggestedItems: []
};
export var GetNextStepsConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetNextStepsConfigResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.suggestedItems) {
            message.suggestedItems = wireFormat.suggestedItems.map(function(i) {
                return SuggestedItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetNextStepsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetNextStepsResponse = {
    jumpBackInItems: [],
    suggestedItems: []
};
export var GetNextStepsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetNextStepsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.jumpBackInItems) {
            message.jumpBackInItems = wireFormat.jumpBackInItems.map(function(i) {
                return JumpBackInItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.suggestedItems) {
            message.suggestedItems = wireFormat.suggestedItems.map(function(i) {
                return SuggestedItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetNudgeConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetNudgeConfigResponse = {
    nudges: []
};
export var GetNudgeConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetNudgeConfigResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.nudges) {
            message.nudges = wireFormat.nudges.map(function(i) {
                return NudgeConfigWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetOnboardingDismissedStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetOnboardingDismissedStatusResponse = {
    isDismissed: false
};
export var GetOnboardingDismissedStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetOnboardingDismissedStatusResponse, wireFormat);
        return message;
    }
};
export var GetOrganizationsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetOrganizationsResponse = {
    organizations: []
};
export var GetOrganizationsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetOrganizationsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.organizations) {
            message.organizations = wireFormat.organizations.map(function(i) {
                return OrganizationCardWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetProfilePreviewRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetProfilePreviewResponse = {
    userName: "",
    displayName: "",
    profileUrl: "",
    thumbnailUrl: "",
    country: "",
    region: "",
    city: "",
    occupation: "",
    isFollowing: false,
    canBeSeen: false
};
export var GetProfilePreviewResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetProfilePreviewResponse, wireFormat);
        if (wireFormat) {
            message.performanceTier = UserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        return message;
    }
};
export var GetProfileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetProfileResponse = {
    userId: 0,
    canEdit: false,
    achievementSummaries: [],
    usersIFollow: [],
    usersFollowingMe: []
};
export var GetProfileResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetProfileResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userLastActive) {
            message.userLastActive = new Date(wireFormat.userLastActive);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userJoinDate) {
            message.userJoinDate = new Date(wireFormat.userJoinDate);
        }
        if (wireFormat) {
            message.performanceTier = UserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        if (wireFormat) {
            message.performanceTierCategory = UserAchievementTypeWireFormat3.fromJson(wireFormat.performanceTierCategory);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.achievementSummaries) {
            message.achievementSummaries = wireFormat.achievementSummaries.map(function(i) {
                return AchievementSummaryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usersIFollow) {
            message.usersIFollow = wireFormat.usersIFollow.map(function(i) {
                return FollowerWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usersFollowingMe) {
            message.usersFollowingMe = wireFormat.usersFollowingMe.map(function(i) {
                return FollowerWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetRecentlyViewedItemsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.returnedType) {
            wireFormat.returnedType = ReturnedItemsTypeWireFormat3.toJson(message.returnedType);
        }
        if (message === null || message === void 0 ? void 0 : message.itemTypeFilter) {
            wireFormat.itemTypeFilter = RecentlyViewedItemTypeWireFormat3.toJson(message.itemTypeFilter);
        }
        return wireFormat;
    }
};
var defaultGetRecentlyViewedItemsResponse = {
    recentlyViewedItems: []
};
export var GetRecentlyViewedItemsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetRecentlyViewedItemsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.recentlyViewedItems) {
            message.recentlyViewedItems = wireFormat.recentlyViewedItems.map(function(i) {
                return RecentlyViewedItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetSupportPhoneNumbersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetSupportPhoneNumbersResponse = {
    phoneInfo: []
};
export var GetSupportPhoneNumbersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSupportPhoneNumbersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.phoneInfo) {
            message.phoneInfo = wireFormat.phoneInfo.map(function(i) {
                return SupportPhoneInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetUploadWarningDismissedRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUploadWarningDismissedResponse = {
    isDismissed: false
};
export var GetUploadWarningDismissedResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUploadWarningDismissedResponse, wireFormat);
        return message;
    }
};
export var GetUserActivityRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserActivityResponse = {
    activities: []
};
export var GetUserActivityResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserActivityResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.activities) {
            message.activities = wireFormat.activities.map(function(i) {
                return ActivityCalendarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetUserCountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserCountResponse = {
    userCount: 0
};
export var GetUserCountResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserCountResponse, wireFormat);
        return message;
    }
};
export var GetUserDiscussionCountsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetUserDiscussionMessagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = DiscussionSortByWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = DiscussionSelectionGroupWireFormat3.toJson(message.group);
        }
        return wireFormat;
    }
};
var defaultGetUserDiscussionMessagesResponse = {
    messages: []
};
export var GetUserDiscussionMessagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserDiscussionMessagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.messages) {
            message.messages = wireFormat.messages.map(function(i) {
                return DiscussionItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetUserEmojiSkinToneRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserEmojiSkinToneResponse = {
    skinTone: 0
};
export var GetUserEmojiSkinToneResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserEmojiSkinToneResponse, wireFormat);
        return message;
    }
};
export var GetUserHatsStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.location) {
            wireFormat.location = HatsLocationWireFormat3.toJson(message.location);
        }
        return wireFormat;
    }
};
var defaultGetUserHatsStatusResponse = {
    showPrompt: false,
    showDiversityStudyPrompt: false
};
export var GetUserHatsStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserHatsStatusResponse, wireFormat);
        if (wireFormat) {
            message.surveyType = SurveyTypeWireFormat3.fromJson(wireFormat.surveyType);
        }
        return message;
    }
};
export var GetUserIdByUsernameOrEmailRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserIdByUsernameOrEmailResponse = {
    userId: 0
};
export var GetUserIdByUsernameOrEmailResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserIdByUsernameOrEmailResponse, wireFormat);
        return message;
    }
};
export var GetUserRankingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = AchievementSummaryTypeWireFormat3.toJson(message.group);
        }
        return wireFormat;
    }
};
export var GetUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var GetUserStatusLogsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserStatusLogsResponse = {
    userStatusLogs: []
};
export var GetUserStatusLogsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserStatusLogsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userStatusLogs) {
            message.userStatusLogs = wireFormat.userStatusLogs.map(function(i) {
                return UserStatusLogWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultJumpBackInCompetition = {};
export var JumpBackInCompetitionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInCompetition, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestSubmissionScore) != undefined) {
            message.latestSubmissionScore = Number(wireFormat.latestSubmissionScore);
        }
        return message;
    }
};
var defaultJumpBackInItem = {
    id: 0,
    actionUrl: "",
    title: ""
};
export var JumpBackInItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInItem, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.avatar) {
            message.avatar = UserAvatarWireFormat3.fromJson(wireFormat.avatar);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competition) {
            message.competition = JumpBackInCompetitionWireFormat3.fromJson(wireFormat.competition);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicDataset) {
            message.publicDataset = JumpBackInPublicDatasetWireFormat3.fromJson(wireFormat.publicDataset);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateDataset) {
            message.privateDataset = JumpBackInPrivateDatasetWireFormat3.fromJson(wireFormat.privateDataset);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicNotebook) {
            message.publicNotebook = JumpBackInPublicNotebookWireFormat3.fromJson(wireFormat.publicNotebook);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateNotebook) {
            message.privateNotebook = JumpBackInPrivateNotebookWireFormat3.fromJson(wireFormat.privateNotebook);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnCourseNotebook) {
            message.learnCourseNotebook = JumpBackInLearnCourseNotebookWireFormat3.fromJson(wireFormat.learnCourseNotebook);
        }
        return message;
    }
};
var defaultJumpBackInLearnCourseNotebook = {
    courseTitle: "",
    lessonTitle: "",
    progress: 0
};
export var JumpBackInLearnCourseNotebookWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInLearnCourseNotebook, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.progress) != undefined) {
            message.progress = Number(wireFormat.progress);
        }
        return message;
    }
};
var defaultJumpBackInPrivateDataset = {
    usabilityRating: 0
};
export var JumpBackInPrivateDatasetWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInPrivateDataset, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) != undefined) {
            message.usabilityRating = Number(wireFormat.usabilityRating);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastVersionUploaded) {
            message.lastVersionUploaded = new Date(wireFormat.lastVersionUploaded);
        }
        return message;
    }
};
var defaultJumpBackInPrivateNotebook = {};
export var JumpBackInPrivateNotebookWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInPrivateNotebook, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastCommitCompletedAt) {
            message.lastCommitCompletedAt = new Date(wireFormat.lastCommitCompletedAt);
        }
        return message;
    }
};
var defaultJumpBackInPublicDataset = {
    totalDownloads: 0,
    newDownloads: 0
};
export var JumpBackInPublicDatasetWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInPublicDataset, wireFormat);
        return message;
    }
};
var defaultJumpBackInPublicNotebook = {
    totalViews: 0,
    newForks: 0
};
export var JumpBackInPublicNotebookWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultJumpBackInPublicNotebook, wireFormat);
        return message;
    }
};
var defaultLeaderboardCounts = {
    count: 0
};
export var LeaderboardCountsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLeaderboardCounts, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultLeaderboardsListItem = {
    userId: 0,
    points: 0,
    totalGoldMedals: 0,
    totalSilverMedals: 0,
    totalBronzeMedals: 0
};
export var LeaderboardsListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLeaderboardsListItem, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.points) != undefined) {
            message.points = Number(wireFormat.points);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.joinTime) {
            message.joinTime = new Date(wireFormat.joinTime);
        }
        return message;
    }
};
export var LegacyChangePasswordRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyDeleteUserLoginRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyGetAccountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyUpdateAccountEmailAddressRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ListAllBookmarksRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListAllBookmarksResponse = {
    bookmarks: []
};
export var ListAllBookmarksResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListAllBookmarksResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bookmarks) {
            message.bookmarks = wireFormat.bookmarks.map(function(i) {
                return BookmarkWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListCurrentUserPenaltyHistoryRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListCurrentUserPenaltyHistoryResponse = {
    userPenalties: []
};
export var ListCurrentUserPenaltyHistoryResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCurrentUserPenaltyHistoryResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userPenalties) {
            message.userPenalties = wireFormat.userPenalties.map(function(i) {
                return CurrentUserPenaltyWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListWorkspacesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListWorkspacesResponse = {
    workspaces: []
};
export var ListWorkspacesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListWorkspacesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.workspaces) {
            message.workspaces = wireFormat.workspaces.map(function(i) {
                return WorkspaceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var MigrateTermsAcceptancesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.date) {
            wireFormat.date = message.date.toISOString();
        }
        return wireFormat;
    }
};
var defaultMigrateTermsAcceptancesResponse = {
    unsuccessfulMigrations: 0
};
export var MigrateTermsAcceptancesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultMigrateTermsAcceptancesResponse, wireFormat);
        return message;
    }
};
export var NewEmailRegistrationUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultNewEmailRegistrationUserResponse = {
    errors: [],
    createdUserId: 0
};
export var NewEmailRegistrationUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultNewEmailRegistrationUserResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.errors) {
            message.errors = wireFormat.errors.map(function(i) {
                return RegistrationErrorWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultNudgeConfig = {
    nudgeId: 0,
    type: "",
    isBuiltIn: false
};
export var NudgeConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultNudgeConfig, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.showingNudgeResponse) {
            message.showingNudgeResponse = ShowingNudgeResponseWireFormat3.fromJson(wireFormat.showingNudgeResponse);
        }
        return message;
    }
};
var defaultOrganizationCard = {
    name: "",
    id: 0,
    thumbnailImageUrl: "",
    slug: ""
};
export var OrganizationCardWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOrganizationCard, wireFormat);
        return message;
    }
};
var defaultPlace = {};
export var PlaceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPlace, wireFormat);
        return message;
    }
};
var defaultPotentialNudge = {
    type: "",
    priority: 0
};
export var PotentialNudgeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPotentialNudge, wireFormat);
        if (wireFormat) {
            message.page = NudgePageWireFormat3.fromJson(wireFormat.page);
        }
        return message;
    }
};
var defaultProfileDto = {
    userId: 0,
    canEdit: false,
    canCreateDatasets: false,
    totalDatasets: 0,
    totalOrganizations: 0,
    pageMessages: [],
    canSeeFollowers: false,
    canSeeCallToAction: false,
    canSeeNotifications: false,
    canSeeAtMentions: false,
    totalScripts: 0,
    isAdmin: false,
    isEditing: false,
    userAllowsUserMessages: false
};
export var ProfileDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultProfileDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userLastActive) {
            message.userLastActive = new Date(wireFormat.userLastActive);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userJoinDate) {
            message.userJoinDate = new Date(wireFormat.userJoinDate);
        }
        if (wireFormat) {
            message.performanceTier = UserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        if (wireFormat) {
            message.performanceTierCategory = AchievementSummaryTypeWireFormat3.fromJson(wireFormat.performanceTierCategory);
        }
        if (wireFormat) {
            message.activePaneTier = UserAchievementTierWireFormat3.fromJson(wireFormat.activePaneTier);
        }
        if (wireFormat) {
            message.activePaneCategory = AchievementSummaryTypeWireFormat3.fromJson(wireFormat.activePaneCategory);
        }
        if (wireFormat) {
            message.activePane = ProfileAreaWireFormat3.fromJson(wireFormat.activePane);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionsSummary) {
            message.competitionsSummary = AchievementSummaryDtoWireFormat3.fromJson(wireFormat.competitionsSummary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.scriptsSummary) {
            message.scriptsSummary = AchievementSummaryDtoWireFormat3.fromJson(wireFormat.scriptsSummary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionsSummary) {
            message.discussionsSummary = AchievementSummaryDtoWireFormat3.fromJson(wireFormat.discussionsSummary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetsSummary) {
            message.datasetsSummary = AchievementSummaryDtoWireFormat3.fromJson(wireFormat.datasetsSummary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pageMessages) {
            message.pageMessages = wireFormat.pageMessages.map(function(i) {
                return KaggleSdkCommonPageMessageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.followers) {
            message.followers = FollowersListDtoWireFormat3.fromJson(wireFormat.followers);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.following) {
            message.following = FollowersListDtoWireFormat3.fromJson(wireFormat.following);
        }
        return message;
    }
};
export var ReactToNudgeRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.reaction) {
            wireFormat.reaction = NudgeReactionsWireFormat3.toJson(message.reaction);
        }
        return wireFormat;
    }
};
var defaultReactToNudgeResponse = {};
export var ReactToNudgeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultReactToNudgeResponse, wireFormat);
        return message;
    }
};
var defaultRecentlyViewedItem = {
    title: "",
    url: "",
    authorSlug: "",
    thumbnailUrl: "",
    id: 0
};
export var RecentlyViewedItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRecentlyViewedItem, wireFormat);
        if (wireFormat) {
            message.itemType = RecentlyViewedItemTypeWireFormat3.fromJson(wireFormat.itemType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mostRecentView) {
            message.mostRecentView = new Date(wireFormat.mostRecentView);
        }
        return message;
    }
};
var defaultRegistrationError = {};
export var RegistrationErrorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRegistrationError, wireFormat);
        if (wireFormat) {
            message.field = RegistrationInfoFieldsWireFormat3.fromJson(wireFormat.field);
        }
        if (wireFormat) {
            message.messageId = LoginMessageIdWireFormat3.fromJson(wireFormat.messageId);
        }
        return message;
    }
};
export var RegistrationValidationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultRegistrationValidationResponse = {
    errors: []
};
export var RegistrationValidationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRegistrationValidationResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.errors) {
            message.errors = wireFormat.errors.map(function(i) {
                return RegistrationErrorWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ReportContentRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.reportReason) {
            wireFormat.reportReason = ReportReasonWireFormat3.toJson(message.reportReason);
        }
        return wireFormat;
    }
};
export var ResendVerificationEmailRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ResetPasswordRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultResetPasswordResponse = {
    returnUrl: ""
};
export var ResetPasswordResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultResetPasswordResponse, wireFormat);
        return message;
    }
};
export var RevokeSiteAdminRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SearchPlacesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchPlacesResponse = {
    places: []
};
export var SearchPlacesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchPlacesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.places) {
            message.places = wireFormat.places.map(function(i) {
                return PlaceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SearchUsersSuggestionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchUsersSuggestionsResponse = {
    usersSuggestions: []
};
export var SearchUsersSuggestionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchUsersSuggestionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usersSuggestions) {
            message.usersSuggestions = wireFormat.usersSuggestions.map(function(i) {
                return UserSuggestionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SetMyAttributesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.attributes) {
            wireFormat.attributes = message.attributes.map(function(i) {
                return AttributeValueWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var SetPhoneReputableRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SetUploadWarningDismissedRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ShowingNudgeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultShowingNudgeResponse = {
    userNudgeId: 0
};
export var ShowingNudgeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultShowingNudgeResponse, wireFormat);
        return message;
    }
};
export var SignOutRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SoftDeleteAccountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSoftDeleteAccountResponse = {
    userSoftDeleted: false,
    datasetsNeedingReview: []
};
export var SoftDeleteAccountResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSoftDeleteAccountResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetsNeedingReview) {
            message.datasetsNeedingReview = wireFormat.datasetsNeedingReview.map(function(i) {
                return KaggleSdkDatasetsDatasetForReviewWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var StartMigrateSsoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultStartMigrateSsoResponse = {};
export var StartMigrateSsoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStartMigrateSsoResponse, wireFormat);
        if (wireFormat) {
            message.outcome = StartMigrateSsoOutcomeWireFormat3.fromJson(wireFormat.outcome);
        }
        return message;
    }
};
export var StartPhoneVerificationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultStartPhoneVerificationResponse = {
    phoneVerified: false,
    india: false
};
export var StartPhoneVerificationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStartPhoneVerificationResponse, wireFormat);
        return message;
    }
};
export var StartResetPasswordRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSuggestedItem = {
    id: 0,
    title: "",
    description: "",
    actionUrl: "",
    icon: ""
};
export var SuggestedItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSuggestedItem, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.progressionStatus) {
            message.progressionStatus = SuggestedProgressionStatusWireFormat3.fromJson(wireFormat.progressionStatus);
        }
        return message;
    }
};
var defaultSuggestedProgressionStatus = {
    isCompleted: false
};
export var SuggestedProgressionStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSuggestedProgressionStatus, wireFormat);
        return message;
    }
};
var defaultSupportPhoneInfo = {
    countryCode: "",
    countryName: "",
    phoneNumber: "",
    supportHoursDescription: ""
};
export var SupportPhoneInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSupportPhoneInfo, wireFormat);
        return message;
    }
};
export var SyncDiscordUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var TakeoutUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.takeoutType) {
            wireFormat.takeoutType = TakeoutTypeWireFormat3.toJson(message.takeoutType);
        }
        return wireFormat;
    }
};
var defaultTakeoutUserResponse = {};
export var TakeoutUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTakeoutUserResponse, wireFormat);
        return message;
    }
};
var defaultTierRequirement = {
    label: "",
    url: "",
    numberRequired: 0,
    numberMet: 0
};
export var TierRequirementWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTierRequirement, wireFormat);
        return message;
    }
};
var defaultTierRequirementGroup = {
    isComplete: false,
    isInProgress: false,
    requirements: []
};
export var TierRequirementGroupWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTierRequirementGroup, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        if (wireFormat) {
            message.type = UserAchievementTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.requirements) {
            message.requirements = wireFormat.requirements.map(function(i) {
                return TierRequirementWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UnfollowUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUnfollowUserResponse = {};
export var UnfollowUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUnfollowUserResponse, wireFormat);
        return message;
    }
};
export var UnsubscribeNewsletterRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UnverifyPhoneRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateBioRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateBioResponse = {};
export var UpdateBioResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateBioResponse, wireFormat);
        return message;
    }
};
export var UpdateDiscordConfigValueRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.config) {
            wireFormat.config = DiscordConfigValueWireFormat3.toJson(message.config);
        }
        return wireFormat;
    }
};
export var UpdateHomepageStatsDismissedStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.state) {
            wireFormat.state = HomepageStatsDismissedStateWireFormat3.toJson(message.state);
        }
        return wireFormat;
    }
};
export var UpdateOnboardingDismissedStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateProfileImageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.profileImage) {
            wireFormat.profileImage = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.profileImage);
        }
        return wireFormat;
    }
};
var defaultUpdateProfileImageResponse = {
    imageUrl: "",
    thumbnailUrl: ""
};
export var UpdateProfileImageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateProfileImageResponse, wireFormat);
        return message;
    }
};
export var UpdateProfileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateProfileResponse = {
    wasSuccessful: false
};
export var UpdateProfileResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateProfileResponse, wireFormat);
        return message;
    }
};
export var UpdateUserEmojiSkinToneRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateWorkspaceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUser = {
    statusId: 0,
    userLogins: [],
    groupIds: [],
    duplicateUsers: [],
    failedNerdchas: 0,
    hasPendingNerdcha: false,
    deleteRequests: [],
    isAdmin: false,
    isKaggleBot: false,
    canAct: false,
    canBeSeen: false,
    isPhoneVerified: false,
    isNewUser: false
};
export var UserWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUser, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.registerDate) {
            message.registerDate = new Date(wireFormat.registerDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastVisitDate) {
            message.lastVisitDate = new Date(wireFormat.lastVisitDate);
        }
        if (wireFormat) {
            message.performanceTier = UserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userLogins) {
            message.userLogins = wireFormat.userLogins.map(function(i) {
                return UserLoginWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.duplicateUsers) {
            message.duplicateUsers = wireFormat.duplicateUsers.map(function(i) {
                return UserWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.securityStamp) {
            message.securityStamp = new Date(wireFormat.securityStamp);
        }
        return message;
    }
};
var defaultUserAvatar = {
    id: 0
};
export var UserAvatarWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserAvatar, wireFormat);
        if (wireFormat) {
            message.tier = UserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tier) {
            wireFormat.tier = UserAchievementTierWireFormat3.toJson(message.tier);
        }
        return wireFormat;
    }
};
var defaultUserLogin = {
    isDisabled: false
};
export var UserLoginWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserLogin, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.linkedDate) {
            message.linkedDate = new Date(wireFormat.linkedDate);
        }
        return message;
    }
};
var defaultUserLoginDto = {
    loginId: 0,
    loginProviderId: 0,
    loginProviderName: ""
};
export var UserLoginDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserLoginDto, wireFormat);
        return message;
    }
};
var defaultUserRankings = {
    totalUsers: 0,
    counts: [],
    list: []
};
export var UserRankingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserRankings, wireFormat);
        if (wireFormat) {
            message.group = AchievementSummaryTypeWireFormat3.fromJson(wireFormat.group);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userRanking) {
            message.userRanking = LeaderboardsListItemWireFormat3.fromJson(wireFormat.userRanking);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.counts) {
            message.counts = wireFormat.counts.map(function(i) {
                return LeaderboardCountsWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.list) {
            message.list = wireFormat.list.map(function(i) {
                return LeaderboardsListItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultUserStatusLog = {
    statusId: 0
};
export var UserStatusLogWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserStatusLog, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logDate) {
            message.logDate = new Date(wireFormat.logDate);
        }
        return message;
    }
};
var defaultUserSuggestion = {
    id: 0,
    userName: "",
    displayName: "",
    thumbnailUrl: "",
    profileUrl: ""
};
export var UserSuggestionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserSuggestion, wireFormat);
        if (wireFormat) {
            message.performanceTier = UserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        return message;
    }
};
export var ValidateResetPasswordCodeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultValidateResetPasswordCodeResponse = {};
export var ValidateResetPasswordCodeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultValidateResetPasswordCodeResponse, wireFormat);
        if (wireFormat) {
            message.outcome = ValidateResetPasswordCodeOutcomeWireFormat3.fromJson(wireFormat.outcome);
        }
        return message;
    }
};
export var VerifyAccountEmailRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultVerifyAccountEmailResponse = {
    localReturnUrl: ""
};
export var VerifyAccountEmailResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVerifyAccountEmailResponse, wireFormat);
        return message;
    }
};
export var VerifyCaptchaRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultVerifyCaptchaResponse = {};
export var VerifyCaptchaResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVerifyCaptchaResponse, wireFormat);
        return message;
    }
};
var defaultVerifyPhoneDto = {
    returnUrl: "",
    alreadySentCode: false
};
export var VerifyPhoneDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVerifyPhoneDto, wireFormat);
        return message;
    }
};
export var VerifyPhoneRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var VerifyPhoneVerificationCodeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultVerifyPhoneVerificationCodeResponse = {
    isSuccessful: false,
    isPhoneVerified: false,
    message: "",
    isDuplicate: false
};
export var VerifyPhoneVerificationCodeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVerifyPhoneVerificationCodeResponse, wireFormat);
        return message;
    }
};
var defaultWorkspace = {
    workspaceId: 0,
    name: "",
    itemCount: 0
};
export var WorkspaceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultWorkspace, wireFormat);
        return message;
    }
};
export var WorkspaceItemWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AccountError;
(function(AccountError) {
    AccountError["UNSPECIFIED"] = "unspecified";
    AccountError[// User needs to verify their phone number.
    "PHONE_VERIFICATION_REQUIRED"] = "phoneVerificationRequired";
    AccountError[// User needs to login.
    "LOGIN_REQUIRED"] = "loginRequired";
})(AccountError || (AccountError = {}));
export var AchievementSummaryType;
(function(AchievementSummaryType) {
    AchievementSummaryType["UNSPECIFIED"] = "unspecified";
    AchievementSummaryType["COMPETITIONS"] = "competitions";
    AchievementSummaryType["NOTEBOOKS"] = "notebooks";
    AchievementSummaryType["DISCUSSION"] = "discussion";
    AchievementSummaryType["DATASETS"] = "datasets";
})(AchievementSummaryType || (AchievementSummaryType = {}));
export var AchievementSummaryTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ACHIEVEMENT_SUMMARY_TYPE_UNSPECIFIED":
            default:
                return AchievementSummaryType.UNSPECIFIED;
            case "ACHIEVEMENT_SUMMARY_TYPE_COMPETITIONS":
                return AchievementSummaryType.COMPETITIONS;
            case "ACHIEVEMENT_SUMMARY_TYPE_NOTEBOOKS":
                return AchievementSummaryType.NOTEBOOKS;
            case "ACHIEVEMENT_SUMMARY_TYPE_DISCUSSION":
                return AchievementSummaryType.DISCUSSION;
            case "ACHIEVEMENT_SUMMARY_TYPE_DATASETS":
                return AchievementSummaryType.DATASETS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case AchievementSummaryType.UNSPECIFIED:
            case 0:
            default:
                return "ACHIEVEMENT_SUMMARY_TYPE_UNSPECIFIED";
            case AchievementSummaryType.COMPETITIONS:
            case 1:
                return "ACHIEVEMENT_SUMMARY_TYPE_COMPETITIONS";
            case AchievementSummaryType.NOTEBOOKS:
            case 2:
                return "ACHIEVEMENT_SUMMARY_TYPE_NOTEBOOKS";
            case AchievementSummaryType.DISCUSSION:
            case 3:
                return "ACHIEVEMENT_SUMMARY_TYPE_DISCUSSION";
            case AchievementSummaryType.DATASETS:
            case 4:
                return "ACHIEVEMENT_SUMMARY_TYPE_DATASETS";
        }
    }
};
export var AttributeId;
(function(AttributeId) {
    AttributeId["UNSPECIFIED"] = "unspecified";
    AttributeId["NOTIFICATIONS_SUBSCRIBE_TO_KAGGLE_NEWSLETTER"] = "notificationsSubscribeToKaggleNewsletter";
    AttributeId["ADDRESS_COUNTRY"] = "addressCountry";
    AttributeId["ADDRESS_REGION"] = "addressRegion";
    AttributeId["ADDRESS_CITY"] = "addressCity";
    AttributeId["WEBSITE"] = "website";
    AttributeId["LINKEDIN_URL"] = "linkedinUrl";
    AttributeId["TWITTER_USER_NAME"] = "twitterUserName";
    AttributeId["GITHUB_USER_NAME"] = "githubUserName";
    AttributeId["BIO"] = "bio";
    AttributeId["SPAMMY"] = "spammy";
    AttributeId["OCCUPATION"] = "occupation";
    AttributeId["ORGANIZATION"] = "organization";
    AttributeId["DISCUSSION_SETTINGS"] = "discussionSettings";
    AttributeId["NOTIFICATIONS_ENABLED"] = "notificationsEnabled";
    AttributeId["NOTIFICATIONS_AT_MENTIONS_SETTING"] = "notificationsAtMentionsSetting";
    AttributeId["NOTIFICATIONS_BLOCK_COLLABORATION_EMAILS"] = "notificationsBlockCollaborationEmails";
    AttributeId["NOTIFICATIONS_DEFAULT_DELIVERY_SETTING"] = "notificationsDefaultDeliverySetting";
    AttributeId["NOTIFICATIONS_AGGREGATION_TYPE"] = "notificationsAggregationType";
    AttributeId["DISMISSABLE_BANNER_NEWSFEED"] = "dismissableBannerNewsfeed";
    AttributeId["KERNEL_EDITOR_NOTEBOOKS_DARK_MODE"] = "kernelEditorNotebooksDarkMode";
    AttributeId["KERNEL_EDITOR_SCRIPTS_DARK_MODE"] = "kernelEditorScriptsDarkMode";
    AttributeId["NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_SUMMARY_EMAIL"] = "notificationsUnsubscribedFromDatasetSummaryEmail";
    AttributeId["HATS_LAST_DISMISSAL_DATE"] = "hatsLastDismissalDate";
    AttributeId["HATS_LAST_CLICK_DATE"] = "hatsLastClickDate";
    AttributeId["NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_FOLLOWED_USER"] = "notificationsNotificationsAtMentionFollowedUser";
    AttributeId["NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_REGULAR_USER"] = "notificationsNotificationsAtMentionRegularUser";
    AttributeId["NOTIFICATIONS_UNSUBSCRIBED_FROM_PRIVATE_DATASET_TASK_SUMMARY_EMAIL"] = "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail";
    AttributeId["NOTIFICATIONS_COMPETITION_ANNOUNCEMENTS"] = "notificationsCompetitionAnnouncements";
    AttributeId["NOTIFICATIONS_COMPETITION_TEAM_UPDATES"] = "notificationsCompetitionTeamUpdates";
    AttributeId["NOTIFICATIONS_ENGAGED_TOPIC_COMMENT"] = "notificationsEngagedTopicComment";
    AttributeId["NOTIFICATIONS_DATASET_ALERTS"] = "notificationsDatasetAlerts";
    AttributeId["DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY_2020_INTERACTION"] = "dataScienceAndMachineLearningSurvey2020Interaction";
    AttributeId["REGISTRATION_RETURN_URL"] = "registrationReturnUrl";
    AttributeId["TAG_COMMUNITY_FILTER"] = "tagCommunityFilter";
    AttributeId["NOTIFICATIONS_NOTEBOOK_ALERTS"] = "notificationsNotebookAlerts";
    AttributeId["BOOKMARKS_COMPETITIONS_MIGRATED"] = "bookmarksCompetitionsMigrated";
    AttributeId["BOOKMARKS_DATASETS_MIGRATED"] = "bookmarksDatasetsMigrated";
    AttributeId["BOOKMARKS_FORUM_TOPICS_MIGRATED"] = "bookmarksForumTopicsMigrated";
    AttributeId["BOOKMARKS_KERNELS_MIGRATED"] = "bookmarksKernelsMigrated";
    AttributeId["EMAIL_NUDGES_DISABLED"] = "emailNudgesDisabled";
    AttributeId["EMPLOYER_NUDGES_DISABLED"] = "employerNudgesDisabled";
    AttributeId["GOOGLE_ML_SUMMIT_2021_INTERACTION"] = "googleMlSummit2021Interaction";
    AttributeId["REGISTRATION_NEWS_EMAIL_SIGNUP_WAS_OPT_OUT"] = "registrationNewsEmailSignupWasOptOut";
    AttributeId["NOTIFICATIONS_USER_NEW_FOLLOWER"] = "notificationsUserNewFollower";
    AttributeId["DS_SURVEY_2021_BANNER_LAST_CLICK_DATE"] = "dsSurvey2021BannerLastClickDate";
    AttributeId["DS_SURVEY_2021_BANNER_LAST_DISMISSAL_DATE"] = "dsSurvey2021BannerLastDismissalDate";
    AttributeId["DS_SURVEY_2021_NUDGE_LAST_CLICK_DATE"] = "dsSurvey2021NudgeLastClickDate";
    AttributeId["DS_SURVEY_2021_NUDGE_LAST_DISMISSAL_DATE"] = "dsSurvey2021NudgeLastDismissalDate";
    AttributeId["MODERATION_REPORTED_BANNER_DISMISSED_KERNEL_IDS"] = "moderationReportedBannerDismissedKernelIds";
    AttributeId["MODERATION_REPORTED_BANNER_DISMISSED_DATASET_IDS"] = "moderationReportedBannerDismissedDatasetIds";
    AttributeId["MODERATION_REPORTED_MODAL_DISMISSED_KERNEL_IDS"] = "moderationReportedModalDismissedKernelIds";
    AttributeId["MODERATION_REPORTED_MODAL_DISMISSED_DATASET_IDS"] = "moderationReportedModalDismissedDatasetIds";
    AttributeId["HOMEPAGE_ONBOARDING_DISMISSED"] = "homepageOnboardingDismissed";
    AttributeId["CUSTOM_NUDGES_DISABLED"] = "customNudgesDisabled";
    AttributeId["IMAGE_UPLOAD_WARNING_DISMISSED"] = "imageUploadWarningDismissed";
    AttributeId["HOMEPAGE_STATS_DISMISSED"] = "homepageStatsDismissed";
    AttributeId[// The user's country code during registration, if they are in an ND4C
    // applicable country. Used by welcome email.
    "REGISTRATION_ND4C_COUNTRY"] = "registrationNd4cCountry";
    AttributeId["TAGLINE"] = "tagline";
    AttributeId[// Whether the user should be shown dataset feedbacks nudges.
    "DATASET_FEEDBACKS_NUDGES_DISABLED"] = "datasetFeedbacksNudgesDisabled";
    AttributeId["PRONOUNS"] = "pronouns";
    AttributeId["USER_EMOJI_SKIN_TONE"] = "userEmojiSkinTone";
    AttributeId[// The KaggleX role (mentor, mentee)
    "KAGGLE_X_ROLE"] = "kaggleXRole";
})(AttributeId || (AttributeId = {}));
export var AttributeIdWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case AttributeId.UNSPECIFIED:
            case 0:
            default:
                return "ATTRIBUTE_ID_UNSPECIFIED";
            case AttributeId.NOTIFICATIONS_SUBSCRIBE_TO_KAGGLE_NEWSLETTER:
            case 17:
                return "ATTRIBUTE_ID_NOTIFICATIONS_SUBSCRIBE_TO_KAGGLE_NEWSLETTER";
            case AttributeId.ADDRESS_COUNTRY:
            case 18:
                return "ATTRIBUTE_ID_ADDRESS_COUNTRY";
            case AttributeId.ADDRESS_REGION:
            case 19:
                return "ATTRIBUTE_ID_ADDRESS_REGION";
            case AttributeId.ADDRESS_CITY:
            case 20:
                return "ATTRIBUTE_ID_ADDRESS_CITY";
            case AttributeId.WEBSITE:
            case 26:
                return "ATTRIBUTE_ID_WEBSITE";
            case AttributeId.LINKEDIN_URL:
            case 27:
                return "ATTRIBUTE_ID_LINKEDIN_URL";
            case AttributeId.TWITTER_USER_NAME:
            case 28:
                return "ATTRIBUTE_ID_TWITTER_USER_NAME";
            case AttributeId.GITHUB_USER_NAME:
            case 29:
                return "ATTRIBUTE_ID_GITHUB_USER_NAME";
            case AttributeId.BIO:
            case 42:
                return "ATTRIBUTE_ID_BIO";
            case AttributeId.SPAMMY:
            case 92:
                return "ATTRIBUTE_ID_SPAMMY";
            case AttributeId.OCCUPATION:
            case 96:
                return "ATTRIBUTE_ID_OCCUPATION";
            case AttributeId.ORGANIZATION:
            case 97:
                return "ATTRIBUTE_ID_ORGANIZATION";
            case AttributeId.DISCUSSION_SETTINGS:
            case 102:
                return "ATTRIBUTE_ID_DISCUSSION_SETTINGS";
            case AttributeId.NOTIFICATIONS_ENABLED:
            case 109:
                return "ATTRIBUTE_ID_NOTIFICATIONS_ENABLED";
            case AttributeId.NOTIFICATIONS_AT_MENTIONS_SETTING:
            case 110:
                return "ATTRIBUTE_ID_NOTIFICATIONS_AT_MENTIONS_SETTING";
            case AttributeId.NOTIFICATIONS_BLOCK_COLLABORATION_EMAILS:
            case 111:
                return "ATTRIBUTE_ID_NOTIFICATIONS_BLOCK_COLLABORATION_EMAILS";
            case AttributeId.NOTIFICATIONS_DEFAULT_DELIVERY_SETTING:
            case 113:
                return "ATTRIBUTE_ID_NOTIFICATIONS_DEFAULT_DELIVERY_SETTING";
            case AttributeId.NOTIFICATIONS_AGGREGATION_TYPE:
            case 114:
                return "ATTRIBUTE_ID_NOTIFICATIONS_AGGREGATION_TYPE";
            case AttributeId.DISMISSABLE_BANNER_NEWSFEED:
            case 115:
                return "ATTRIBUTE_ID_DISMISSABLE_BANNER_NEWSFEED";
            case AttributeId.KERNEL_EDITOR_NOTEBOOKS_DARK_MODE:
            case 116:
                return "ATTRIBUTE_ID_KERNEL_EDITOR_NOTEBOOKS_DARK_MODE";
            case AttributeId.KERNEL_EDITOR_SCRIPTS_DARK_MODE:
            case 117:
                return "ATTRIBUTE_ID_KERNEL_EDITOR_SCRIPTS_DARK_MODE";
            case AttributeId.NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_SUMMARY_EMAIL:
            case 118:
                return "ATTRIBUTE_ID_NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_SUMMARY_EMAIL";
            case AttributeId.HATS_LAST_DISMISSAL_DATE:
            case 120:
                return "ATTRIBUTE_ID_HATS_LAST_DISMISSAL_DATE";
            case AttributeId.HATS_LAST_CLICK_DATE:
            case 121:
                return "ATTRIBUTE_ID_HATS_LAST_CLICK_DATE";
            case AttributeId.NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_FOLLOWED_USER:
            case 124:
                return "ATTRIBUTE_ID_NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_FOLLOWED_USER";
            case AttributeId.NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_REGULAR_USER:
            case 125:
                return "ATTRIBUTE_ID_NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_REGULAR_USER";
            case AttributeId.NOTIFICATIONS_UNSUBSCRIBED_FROM_PRIVATE_DATASET_TASK_SUMMARY_EMAIL:
            case 127:
                return "ATTRIBUTE_ID_NOTIFICATIONS_UNSUBSCRIBED_FROM_PRIVATE_DATASET_TASK_SUMMARY_EMAIL";
            case AttributeId.NOTIFICATIONS_COMPETITION_ANNOUNCEMENTS:
            case 128:
                return "ATTRIBUTE_ID_NOTIFICATIONS_COMPETITION_ANNOUNCEMENTS";
            case AttributeId.NOTIFICATIONS_COMPETITION_TEAM_UPDATES:
            case 129:
                return "ATTRIBUTE_ID_NOTIFICATIONS_COMPETITION_TEAM_UPDATES";
            case AttributeId.NOTIFICATIONS_ENGAGED_TOPIC_COMMENT:
            case 130:
                return "ATTRIBUTE_ID_NOTIFICATIONS_ENGAGED_TOPIC_COMMENT";
            case AttributeId.NOTIFICATIONS_DATASET_ALERTS:
            case 131:
                return "ATTRIBUTE_ID_NOTIFICATIONS_DATASET_ALERTS";
            case AttributeId.DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY_2020_INTERACTION:
            case 132:
                return "ATTRIBUTE_ID_DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY_2020_INTERACTION";
            case AttributeId.REGISTRATION_RETURN_URL:
            case 133:
                return "ATTRIBUTE_ID_REGISTRATION_RETURN_URL";
            case AttributeId.TAG_COMMUNITY_FILTER:
            case 134:
                return "ATTRIBUTE_ID_TAG_COMMUNITY_FILTER";
            case AttributeId.NOTIFICATIONS_NOTEBOOK_ALERTS:
            case 136:
                return "ATTRIBUTE_ID_NOTIFICATIONS_NOTEBOOK_ALERTS";
            case AttributeId.BOOKMARKS_COMPETITIONS_MIGRATED:
            case 137:
                return "ATTRIBUTE_ID_BOOKMARKS_COMPETITIONS_MIGRATED";
            case AttributeId.BOOKMARKS_DATASETS_MIGRATED:
            case 138:
                return "ATTRIBUTE_ID_BOOKMARKS_DATASETS_MIGRATED";
            case AttributeId.BOOKMARKS_FORUM_TOPICS_MIGRATED:
            case 139:
                return "ATTRIBUTE_ID_BOOKMARKS_FORUM_TOPICS_MIGRATED";
            case AttributeId.BOOKMARKS_KERNELS_MIGRATED:
            case 140:
                return "ATTRIBUTE_ID_BOOKMARKS_KERNELS_MIGRATED";
            case AttributeId.EMAIL_NUDGES_DISABLED:
            case 141:
                return "ATTRIBUTE_ID_EMAIL_NUDGES_DISABLED";
            case AttributeId.EMPLOYER_NUDGES_DISABLED:
            case 142:
                return "ATTRIBUTE_ID_EMPLOYER_NUDGES_DISABLED";
            case AttributeId.GOOGLE_ML_SUMMIT_2021_INTERACTION:
            case 143:
                return "ATTRIBUTE_ID_GOOGLE_ML_SUMMIT_2021_INTERACTION";
            case AttributeId.REGISTRATION_NEWS_EMAIL_SIGNUP_WAS_OPT_OUT:
            case 144:
                return "ATTRIBUTE_ID_REGISTRATION_NEWS_EMAIL_SIGNUP_WAS_OPT_OUT";
            case AttributeId.NOTIFICATIONS_USER_NEW_FOLLOWER:
            case 145:
                return "ATTRIBUTE_ID_NOTIFICATIONS_USER_NEW_FOLLOWER";
            case AttributeId.DS_SURVEY_2021_BANNER_LAST_CLICK_DATE:
            case 146:
                return "ATTRIBUTE_ID_DS_SURVEY_2021_BANNER_LAST_CLICK_DATE";
            case AttributeId.DS_SURVEY_2021_BANNER_LAST_DISMISSAL_DATE:
            case 147:
                return "ATTRIBUTE_ID_DS_SURVEY_2021_BANNER_LAST_DISMISSAL_DATE";
            case AttributeId.DS_SURVEY_2021_NUDGE_LAST_CLICK_DATE:
            case 148:
                return "ATTRIBUTE_ID_DS_SURVEY_2021_NUDGE_LAST_CLICK_DATE";
            case AttributeId.DS_SURVEY_2021_NUDGE_LAST_DISMISSAL_DATE:
            case 149:
                return "ATTRIBUTE_ID_DS_SURVEY_2021_NUDGE_LAST_DISMISSAL_DATE";
            case AttributeId.MODERATION_REPORTED_BANNER_DISMISSED_KERNEL_IDS:
            case 150:
                return "ATTRIBUTE_ID_MODERATION_REPORTED_BANNER_DISMISSED_KERNEL_IDS";
            case AttributeId.MODERATION_REPORTED_BANNER_DISMISSED_DATASET_IDS:
            case 151:
                return "ATTRIBUTE_ID_MODERATION_REPORTED_BANNER_DISMISSED_DATASET_IDS";
            case AttributeId.MODERATION_REPORTED_MODAL_DISMISSED_KERNEL_IDS:
            case 152:
                return "ATTRIBUTE_ID_MODERATION_REPORTED_MODAL_DISMISSED_KERNEL_IDS";
            case AttributeId.MODERATION_REPORTED_MODAL_DISMISSED_DATASET_IDS:
            case 153:
                return "ATTRIBUTE_ID_MODERATION_REPORTED_MODAL_DISMISSED_DATASET_IDS";
            case AttributeId.HOMEPAGE_ONBOARDING_DISMISSED:
            case 154:
                return "ATTRIBUTE_ID_HOMEPAGE_ONBOARDING_DISMISSED";
            case AttributeId.CUSTOM_NUDGES_DISABLED:
            case 155:
                return "ATTRIBUTE_ID_CUSTOM_NUDGES_DISABLED";
            case AttributeId.IMAGE_UPLOAD_WARNING_DISMISSED:
            case 156:
                return "ATTRIBUTE_ID_IMAGE_UPLOAD_WARNING_DISMISSED";
            case AttributeId.HOMEPAGE_STATS_DISMISSED:
            case 157:
                return "ATTRIBUTE_ID_HOMEPAGE_STATS_DISMISSED";
            case AttributeId.REGISTRATION_ND4C_COUNTRY:
            case 158:
                return "ATTRIBUTE_ID_REGISTRATION_ND4C_COUNTRY";
            case AttributeId.TAGLINE:
            case 159:
                return "ATTRIBUTE_ID_TAGLINE";
            case AttributeId.DATASET_FEEDBACKS_NUDGES_DISABLED:
            case 160:
                return "ATTRIBUTE_ID_DATASET_FEEDBACKS_NUDGES_DISABLED";
            case AttributeId.PRONOUNS:
            case 161:
                return "ATTRIBUTE_ID_PRONOUNS";
            case AttributeId.USER_EMOJI_SKIN_TONE:
            case 162:
                return "ATTRIBUTE_ID_USER_EMOJI_SKIN_TONE";
            case AttributeId.KAGGLE_X_ROLE:
            case 163:
                return "ATTRIBUTE_ID_KAGGLE_X_ROLE";
        }
    }
};
export var BookmarkType;
(function(BookmarkType) {
    BookmarkType["UNSPECIFIED"] = "unspecified";
    BookmarkType["COMPETITION"] = "competition";
    BookmarkType["DATASET"] = "dataset";
    BookmarkType["FORUM_TOPIC"] = "forumTopic";
    BookmarkType["KERNEL"] = "kernel";
})(BookmarkType || (BookmarkType = {}));
export var BookmarkTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "BOOKMARK_TYPE_UNSPECIFIED":
            default:
                return BookmarkType.UNSPECIFIED;
            case "BOOKMARK_TYPE_COMPETITION":
                return BookmarkType.COMPETITION;
            case "BOOKMARK_TYPE_DATASET":
                return BookmarkType.DATASET;
            case "BOOKMARK_TYPE_FORUM_TOPIC":
                return BookmarkType.FORUM_TOPIC;
            case "BOOKMARK_TYPE_KERNEL":
                return BookmarkType.KERNEL;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case BookmarkType.UNSPECIFIED:
            case 0:
            default:
                return "BOOKMARK_TYPE_UNSPECIFIED";
            case BookmarkType.COMPETITION:
            case 1:
                return "BOOKMARK_TYPE_COMPETITION";
            case BookmarkType.DATASET:
            case 2:
                return "BOOKMARK_TYPE_DATASET";
            case BookmarkType.FORUM_TOPIC:
            case 3:
                return "BOOKMARK_TYPE_FORUM_TOPIC";
            case BookmarkType.KERNEL:
            case 4:
                return "BOOKMARK_TYPE_KERNEL";
        }
    }
};
export var CheckResult;
(function(CheckResult) {
    CheckResult["UNDEFINED"] = "undefined";
    CheckResult["OK"] = "ok";
    CheckResult[// Negative check result causes:
    "CUSTOM_NUDGES_DISABLED"] = "customNudgesDisabled";
    CheckResult["DATASET_FEEDBACKS_NUDGES_DISABLED"] = "datasetFeedbacksNudgesDisabled";
    CheckResult["CAN_SEE_EXPRESSION"] = "canSeeExpression";
    CheckResult["NOT_FOUND"] = "notFound";
    CheckResult["USER_AADC"] = "userAadc";
    CheckResult["USER_SEEN_ALREADY"] = "userSeenAlready";
})(CheckResult || (CheckResult = {}));
export var CheckResultWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "CHECK_RESULT_UNDEFINED":
            default:
                return CheckResult.UNDEFINED;
            case "OK":
                return CheckResult.OK;
            case "CUSTOM_NUDGES_DISABLED":
                return CheckResult.CUSTOM_NUDGES_DISABLED;
            case "DATASET_FEEDBACKS_NUDGES_DISABLED":
                return CheckResult.DATASET_FEEDBACKS_NUDGES_DISABLED;
            case "CAN_SEE_EXPRESSION":
                return CheckResult.CAN_SEE_EXPRESSION;
            case "NOT_FOUND":
                return CheckResult.NOT_FOUND;
            case "USER_AADC":
                return CheckResult.USER_AADC;
            case "USER_SEEN_ALREADY":
                return CheckResult.USER_SEEN_ALREADY;
        }
    }
};
export var CollaboratorType;
(function(CollaboratorType) {
    CollaboratorType["UNSPECIFIED"] = "unspecified";
    CollaboratorType["READER"] = "reader";
    CollaboratorType["WRITER"] = "writer";
    CollaboratorType["OWNER"] = "owner";
})(CollaboratorType || (CollaboratorType = {}));
export var CollaboratorTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COLLABORATOR_TYPE_UNSPECIFIED":
            default:
                return CollaboratorType.UNSPECIFIED;
            case "READER":
                return CollaboratorType.READER;
            case "WRITER":
                return CollaboratorType.WRITER;
            case "OWNER":
                return CollaboratorType.OWNER;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CollaboratorType.UNSPECIFIED:
            case 0:
            default:
                return "COLLABORATOR_TYPE_UNSPECIFIED";
            case CollaboratorType.READER:
            case 1:
                return "READER";
            case CollaboratorType.WRITER:
            case 2:
                return "WRITER";
            case CollaboratorType.OWNER:
            case 3:
                return "OWNER";
        }
    }
};
export var ContactSupportType;
(function(ContactSupportType) {
    ContactSupportType["UNSPECIFIED"] = "unspecified";
    ContactSupportType["SUPPORT"] = "support";
    ContactSupportType["MODERATION"] = "moderation";
})(ContactSupportType || (ContactSupportType = {}));
export var ContactSupportTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ContactSupportType.UNSPECIFIED:
            case 0:
            default:
                return "UNSPECIFIED";
            case ContactSupportType.SUPPORT:
            case 1:
                return "SUPPORT";
            case ContactSupportType.MODERATION:
            case 2:
                return "MODERATION";
        }
    }
};
export var ContactUserInfoError;
(function(ContactUserInfoError) {
    ContactUserInfoError["UNSPECIFIED"] = "unspecified";
    ContactUserInfoError["CONTACT_USER_INFO_NOVICE_USER"] = "contactUserInfoNoviceUser";
    ContactUserInfoError["CONTACT_USER_INFO_QUOTA_REACHED"] = "contactUserInfoQuotaReached";
    ContactUserInfoError["CONTACT_USER_INFO_NOT_PHONE_VERIFIED"] = "contactUserInfoNotPhoneVerified";
})(ContactUserInfoError || (ContactUserInfoError = {}));
export var ContactUserInfoErrorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "CONTACT_USER_INFO_ERROR_UNSPECIFIED":
            default:
                return ContactUserInfoError.UNSPECIFIED;
            case "CONTACT_USER_INFO_NOVICE_USER":
                return ContactUserInfoError.CONTACT_USER_INFO_NOVICE_USER;
            case "CONTACT_USER_INFO_QUOTA_REACHED":
                return ContactUserInfoError.CONTACT_USER_INFO_QUOTA_REACHED;
            case "CONTACT_USER_INFO_NOT_PHONE_VERIFIED":
                return ContactUserInfoError.CONTACT_USER_INFO_NOT_PHONE_VERIFIED;
        }
    }
};
export var ConversionMethod;
(function(ConversionMethod) {
    ConversionMethod["UNSPECIFIED"] = "unspecified";
    ConversionMethod["MIGRATE"] = "migrate";
    ConversionMethod["DISPOSE"] = "dispose";
})(ConversionMethod || (ConversionMethod = {}));
export var ConversionMethodWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ConversionMethod.UNSPECIFIED:
            case 0:
            default:
                return "CONVERSION_METHOD_UNSPECIFIED";
            case ConversionMethod.MIGRATE:
            case 1:
                return "CONVERSION_METHOD_MIGRATE";
            case ConversionMethod.DISPOSE:
            case 2:
                return "CONVERSION_METHOD_DISPOSE";
        }
    }
};
export var DiscussionSelectionGroup;
(function(DiscussionSelectionGroup) {
    DiscussionSelectionGroup["UNSPECIFIED"] = "unspecified";
    DiscussionSelectionGroup["COMMENTS_AND_TOPICS"] = "commentsAndTopics";
    DiscussionSelectionGroup["COMMENTS"] = "comments";
    DiscussionSelectionGroup["TOPICS"] = "topics";
    DiscussionSelectionGroup["UPVOTED"] = "upvoted";
})(DiscussionSelectionGroup || (DiscussionSelectionGroup = {}));
export var DiscussionSelectionGroupWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DiscussionSelectionGroup.UNSPECIFIED:
            case 0:
            default:
                return "DISCUSSION_SELECTION_GROUP_UNSPECIFIED";
            case DiscussionSelectionGroup.COMMENTS_AND_TOPICS:
            case 1:
                return "COMMENTS_AND_TOPICS";
            case DiscussionSelectionGroup.COMMENTS:
            case 2:
                return "COMMENTS";
            case DiscussionSelectionGroup.TOPICS:
            case 3:
                return "TOPICS";
            case DiscussionSelectionGroup.UPVOTED:
            case 4:
                return "UPVOTED";
        }
    }
};
export var DiscussionSortBy;
(function(DiscussionSortBy) {
    DiscussionSortBy["UNSPECIFIED"] = "unspecified";
    DiscussionSortBy["LATEST_POST"] = "latestPost";
    DiscussionSortBy["MOST_VOTES"] = "mostVotes";
})(DiscussionSortBy || (DiscussionSortBy = {}));
export var DiscussionSortByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DiscussionSortBy.UNSPECIFIED:
            case 0:
            default:
                return "DISCUSSION_SORT_BY_UNSPECIFIED";
            case DiscussionSortBy.LATEST_POST:
            case 1:
                return "LATEST_POST";
            case DiscussionSortBy.MOST_VOTES:
            case 2:
                return "MOST_VOTES";
        }
    }
};
export var DiscussionType;
(function(DiscussionType) {
    DiscussionType["UNSPECIFIED"] = "unspecified";
    DiscussionType["SCRIPT_COMMENT"] = "scriptComment";
    DiscussionType["FORUM_TOPIC"] = "forumTopic";
    DiscussionType["FORUM_MESSAGE"] = "forumMessage";
})(DiscussionType || (DiscussionType = {}));
export var DiscussionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DISCUSSION_TYPE_UNSPECIFIED":
            default:
                return DiscussionType.UNSPECIFIED;
            case "SCRIPT_COMMENT":
                return DiscussionType.SCRIPT_COMMENT;
            case "FORUM_TOPIC":
                return DiscussionType.FORUM_TOPIC;
            case "FORUM_MESSAGE":
                return DiscussionType.FORUM_MESSAGE;
        }
    }
};
export var FollowersListType;
(function(FollowersListType) {
    FollowersListType["UNSPECIFIED"] = "unspecified";
    FollowersListType["FOLLOWERS"] = "followers";
    FollowersListType["FOLLOWING"] = "following";
})(FollowersListType || (FollowersListType = {}));
export var FollowersListTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "FOLLOWERS_LIST_TYPE_UNSPECIFIED":
            default:
                return FollowersListType.UNSPECIFIED;
            case "FOLLOWERS_LIST_TYPE_FOLLOWERS":
                return FollowersListType.FOLLOWERS;
            case "FOLLOWERS_LIST_TYPE_FOLLOWING":
                return FollowersListType.FOLLOWING;
        }
    }
};
export var HatsLocation;
(function(HatsLocation) {
    HatsLocation["UNSPECIFIED"] = "unspecified";
    HatsLocation["HOMEPAGE"] = "homepage";
    HatsLocation["COMPETITIONS"] = "competitions";
    HatsLocation["DATASETS"] = "datasets";
    HatsLocation["NOTEBOOKS"] = "notebooks";
    HatsLocation["COURSES"] = "courses";
    HatsLocation["DISCUSSIONS"] = "discussions";
    HatsLocation["MODELS"] = "models";
})(HatsLocation || (HatsLocation = {}));
export var HatsLocationWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case HatsLocation.UNSPECIFIED:
            case 0:
            default:
                return "HATS_LOCATION_UNSPECIFIED";
            case HatsLocation.HOMEPAGE:
            case 1:
                return "HOMEPAGE";
            case HatsLocation.COMPETITIONS:
            case 2:
                return "COMPETITIONS";
            case HatsLocation.DATASETS:
            case 3:
                return "DATASETS";
            case HatsLocation.NOTEBOOKS:
            case 4:
                return "NOTEBOOKS";
            case HatsLocation.COURSES:
            case 5:
                return "COURSES";
            case HatsLocation.DISCUSSIONS:
            case 6:
                return "DISCUSSIONS";
            case HatsLocation.MODELS:
            case 7:
                return "MODELS";
        }
    }
};
export var HomepageStatsDismissedState;
(function(HomepageStatsDismissedState) {
    HomepageStatsDismissedState["DEFAULT"] = "default";
    HomepageStatsDismissedState["DISMISSED"] = "dismissed";
    HomepageStatsDismissedState["DISPLAYED"] = "displayed";
})(HomepageStatsDismissedState || (HomepageStatsDismissedState = {}));
export var HomepageStatsDismissedStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DEFAULT":
            default:
                return HomepageStatsDismissedState.DEFAULT;
            case "DISMISSED":
                return HomepageStatsDismissedState.DISMISSED;
            case "DISPLAYED":
                return HomepageStatsDismissedState.DISPLAYED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case HomepageStatsDismissedState.DEFAULT:
            case 0:
            default:
                return "DEFAULT";
            case HomepageStatsDismissedState.DISMISSED:
            case 1:
                return "DISMISSED";
            case HomepageStatsDismissedState.DISPLAYED:
            case 2:
                return "DISPLAYED";
        }
    }
};
export var KaggleXRole;
(function(KaggleXRole) {
    KaggleXRole["KAGGLE_X_ROLE_UNSPECIFIED"] = "kaggleXRoleUnspecified";
    KaggleXRole["COHORT_3_MENTOR"] = "cohort3Mentor";
    KaggleXRole["COHORT_3_MENTEE"] = "cohort3Mentee";
})(KaggleXRole || (KaggleXRole = {}));
export var KaggleXRoleWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KaggleXRole.KAGGLE_X_ROLE_UNSPECIFIED:
            case 0:
            default:
                return "KAGGLE_X_ROLE_UNSPECIFIED";
            case KaggleXRole.COHORT_3_MENTOR:
            case 1:
                return "COHORT_3_MENTOR";
            case KaggleXRole.COHORT_3_MENTEE:
            case 2:
                return "COHORT_3_MENTEE";
        }
    }
};
export var LoginMessageId;
(function(LoginMessageId) {
    LoginMessageId["UNSPECIFIED"] = "unspecified";
    LoginMessageId["UNKNOWN"] = "unknown";
    LoginMessageId["LOCKED_OUT"] = "lockedOut";
    LoginMessageId["INVALID_LOGIN"] = "invalidLogin";
    LoginMessageId["INVALID_GOOGLE_SSO"] = "invalidGoogleSso";
    LoginMessageId["MISSING_LOGIN"] = "missingLogin";
    LoginMessageId["DISABLED_LOGIN"] = "disabledLogin";
    LoginMessageId["INTERNAL_ERROR"] = "internalError";
    LoginMessageId["BANNED_LOGIN"] = "bannedLogin";
    LoginMessageId["ALREADY_CONFIRMED"] = "alreadyConfirmed";
    LoginMessageId["EXPIRED_CODE"] = "expiredCode";
    LoginMessageId["GOOGLE_SSO_EMAIL_MISSING"] = "googleSsoEmailMissing";
    LoginMessageId["GOOGLE_LINK_SUCCESS"] = "googleLinkSuccess";
    LoginMessageId["GOOGLE_SSO_INACTIVE"] = "googleSsoInactive";
    LoginMessageId["ADMINS_USE_GOOGLE"] = "adminsUseGoogle";
    LoginMessageId["ADMINS_USE_GOOGLE_EMAIL"] = "adminsUseGoogleEmail";
    LoginMessageId["DATASETS_WELCOME"] = "datasetsWelcome";
    LoginMessageId["CAPTCHA_MISSING"] = "captchaMissing";
    LoginMessageId["USERNAME_TAKEN"] = "usernameTaken";
    LoginMessageId["USERNAME_NUMBER"] = "usernameNumber";
    LoginMessageId["USERNAME_ALPHANUMERIC"] = "usernameAlphanumeric";
    LoginMessageId["USERNAME_MIN_LENGTH"] = "usernameMinLength";
    LoginMessageId["USERNAME_MAX_LENGTH"] = "usernameMaxLength";
    LoginMessageId["FULL_NAME_LENGTH"] = "fullNameLength";
    LoginMessageId["EMAIL_EXISTS"] = "emailExists";
    LoginMessageId["EMAIL_LENGTH"] = "emailLength";
    LoginMessageId["INVALID_EMAIL"] = "invalidEmail";
    LoginMessageId["PASSWORD_TOO_SHORT"] = "passwordTooShort";
    LoginMessageId["DATASETS_LOGIN"] = "datasetsLogin";
    LoginMessageId["TOPIC_LOGIN"] = "topicLogin";
    LoginMessageId["VOTE_LOGIN"] = "voteLogin";
    LoginMessageId["CONTACT_USERS"] = "contactUsers";
    LoginMessageId["USE_GOOGLE_SSO"] = "useGoogleSso";
    LoginMessageId["MISSING_EMAIL"] = "missingEmail";
    LoginMessageId["MISSING_USER_NAME"] = "missingUserName";
    LoginMessageId["MISSING_DISPLAY_NAME"] = "missingDisplayName";
    LoginMessageId["MISSING_PASSWORD"] = "missingPassword";
    LoginMessageId["BOOKMARK_LOGIN"] = "bookmarkLogin";
    LoginMessageId["INVALID_CODE"] = "invalidCode";
    LoginMessageId["CHANGE_EMAIL_VERIFY_LOGIN"] = "changeEmailVerifyLogin";
    LoginMessageId["FOLLOW_LOGIN"] = "followLogin";
    LoginMessageId["SUSPENDED_LOGIN"] = "suspendedLogin";
    LoginMessageId["GOOGLE_SSO_EXISTING_ALIAS"] = "googleSsoExistingAlias";
})(LoginMessageId || (LoginMessageId = {}));
export var LoginMessageIdWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "LOGIN_MESSAGE_ID_UNSPECIFIED":
            default:
                return LoginMessageId.UNSPECIFIED;
            case "UNKNOWN":
                return LoginMessageId.UNKNOWN;
            case "LOCKED_OUT":
                return LoginMessageId.LOCKED_OUT;
            case "INVALID_LOGIN":
                return LoginMessageId.INVALID_LOGIN;
            case "INVALID_GOOGLE_SSO":
                return LoginMessageId.INVALID_GOOGLE_SSO;
            case "MISSING_LOGIN":
                return LoginMessageId.MISSING_LOGIN;
            case "DISABLED_LOGIN":
                return LoginMessageId.DISABLED_LOGIN;
            case "INTERNAL_ERROR":
                return LoginMessageId.INTERNAL_ERROR;
            case "BANNED_LOGIN":
                return LoginMessageId.BANNED_LOGIN;
            case "ALREADY_CONFIRMED":
                return LoginMessageId.ALREADY_CONFIRMED;
            case "EXPIRED_CODE":
                return LoginMessageId.EXPIRED_CODE;
            case "GOOGLE_SSO_EMAIL_MISSING":
                return LoginMessageId.GOOGLE_SSO_EMAIL_MISSING;
            case "GOOGLE_LINK_SUCCESS":
                return LoginMessageId.GOOGLE_LINK_SUCCESS;
            case "GOOGLE_SSO_INACTIVE":
                return LoginMessageId.GOOGLE_SSO_INACTIVE;
            case "ADMINS_USE_GOOGLE":
                return LoginMessageId.ADMINS_USE_GOOGLE;
            case "ADMINS_USE_GOOGLE_EMAIL":
                return LoginMessageId.ADMINS_USE_GOOGLE_EMAIL;
            case "DATASETS_WELCOME":
                return LoginMessageId.DATASETS_WELCOME;
            case "CAPTCHA_MISSING":
                return LoginMessageId.CAPTCHA_MISSING;
            case "USERNAME_TAKEN":
                return LoginMessageId.USERNAME_TAKEN;
            case "USERNAME_NUMBER":
                return LoginMessageId.USERNAME_NUMBER;
            case "USERNAME_ALPHANUMERIC":
                return LoginMessageId.USERNAME_ALPHANUMERIC;
            case "USERNAME_MIN_LENGTH":
                return LoginMessageId.USERNAME_MIN_LENGTH;
            case "USERNAME_MAX_LENGTH":
                return LoginMessageId.USERNAME_MAX_LENGTH;
            case "FULL_NAME_LENGTH":
                return LoginMessageId.FULL_NAME_LENGTH;
            case "EMAIL_EXISTS":
                return LoginMessageId.EMAIL_EXISTS;
            case "EMAIL_LENGTH":
                return LoginMessageId.EMAIL_LENGTH;
            case "INVALID_EMAIL":
                return LoginMessageId.INVALID_EMAIL;
            case "PASSWORD_TOO_SHORT":
                return LoginMessageId.PASSWORD_TOO_SHORT;
            case "DATASETS_LOGIN":
                return LoginMessageId.DATASETS_LOGIN;
            case "TOPIC_LOGIN":
                return LoginMessageId.TOPIC_LOGIN;
            case "VOTE_LOGIN":
                return LoginMessageId.VOTE_LOGIN;
            case "CONTACT_USERS":
                return LoginMessageId.CONTACT_USERS;
            case "USE_GOOGLE_SSO":
                return LoginMessageId.USE_GOOGLE_SSO;
            case "MISSING_EMAIL":
                return LoginMessageId.MISSING_EMAIL;
            case "MISSING_USER_NAME":
                return LoginMessageId.MISSING_USER_NAME;
            case "MISSING_DISPLAY_NAME":
                return LoginMessageId.MISSING_DISPLAY_NAME;
            case "MISSING_PASSWORD":
                return LoginMessageId.MISSING_PASSWORD;
            case "BOOKMARK_LOGIN":
                return LoginMessageId.BOOKMARK_LOGIN;
            case "INVALID_CODE":
                return LoginMessageId.INVALID_CODE;
            case "CHANGE_EMAIL_VERIFY_LOGIN":
                return LoginMessageId.CHANGE_EMAIL_VERIFY_LOGIN;
            case "FOLLOW_LOGIN":
                return LoginMessageId.FOLLOW_LOGIN;
            case "SUSPENDED_LOGIN":
                return LoginMessageId.SUSPENDED_LOGIN;
            case "GOOGLE_SSO_EXISTING_ALIAS":
                return LoginMessageId.GOOGLE_SSO_EXISTING_ALIAS;
        }
    }
};
export var Medal;
(function(Medal) {
    Medal["UNSPECIFIED"] = "unspecified";
    Medal["GOLD"] = "gold";
    Medal["SILVER"] = "silver";
    Medal["BRONZE"] = "bronze";
})(Medal || (Medal = {}));
export var MedalWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MEDAL_UNSPECIFIED":
            default:
                return Medal.UNSPECIFIED;
            case "GOLD":
                return Medal.GOLD;
            case "SILVER":
                return Medal.SILVER;
            case "BRONZE":
                return Medal.BRONZE;
        }
    }
};
export var NudgePage;
(function(NudgePage) {
    NudgePage["ANY"] = "any";
    NudgePage["COMPETITIONS"] = "competitions";
    NudgePage["PROFILE"] = "profile";
    NudgePage["LANDING"] = "landing";
    NudgePage["DATASETS"] = "datasets";
})(NudgePage || (NudgePage = {}));
export var NudgePageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NUDGE_PAGE_ANY":
            default:
                return NudgePage.ANY;
            case "NUDGE_PAGE_COMPETITIONS":
                return NudgePage.COMPETITIONS;
            case "NUDGE_PAGE_PROFILE":
                return NudgePage.PROFILE;
            case "NUDGE_PAGE_LANDING":
                return NudgePage.LANDING;
            case "NUDGE_PAGE_DATASETS":
                return NudgePage.DATASETS;
        }
    }
};
export var NudgeReactions;
(function(NudgeReactions) {
    NudgeReactions["REASON_UNSPECIFIED"] = "reasonUnspecified";
    NudgeReactions["USER_DISMISSED"] = "userDismissed";
    NudgeReactions["ACCEPTED"] = "accepted";
    NudgeReactions["AUTO_DISMISSED"] = "autoDismissed";
})(NudgeReactions || (NudgeReactions = {}));
export var NudgeReactionsWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case NudgeReactions.REASON_UNSPECIFIED:
            case 0:
            default:
                return "REASON_UNSPECIFIED";
            case NudgeReactions.USER_DISMISSED:
            case 1:
                return "USER_DISMISSED";
            case NudgeReactions.ACCEPTED:
            case 2:
                return "ACCEPTED";
            case NudgeReactions.AUTO_DISMISSED:
            case 3:
                return "AUTO_DISMISSED";
        }
    }
};
export var ProfileArea;
(function(ProfileArea) {
    ProfileArea["UNSPECIFIED"] = "unspecified";
    ProfileArea["HOME"] = "home";
    ProfileArea["COMPETITIONS"] = "competitions";
    ProfileArea["CODE"] = "code";
    ProfileArea["DISCUSSION"] = "discussion";
    ProfileArea["DATASETS"] = "datasets";
    ProfileArea["ACCOUNT"] = "account";
    ProfileArea["CONTACT"] = "contact";
    ProfileArea["FOLLOWERS"] = "followers";
    ProfileArea["FOLLOWING"] = "following";
    ProfileArea["GENIE"] = "genie";
    ProfileArea["NOTIFICATIONS"] = "notifications";
    ProfileArea["NOTEBOOKS"] = "notebooks";
})(ProfileArea || (ProfileArea = {}));
export var ProfileAreaWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "PROFILE_AREA_UNSPECIFIED":
            default:
                return ProfileArea.UNSPECIFIED;
            case "PROFILE_AREA_HOME":
                return ProfileArea.HOME;
            case "PROFILE_AREA_COMPETITIONS":
                return ProfileArea.COMPETITIONS;
            case "PROFILE_AREA_CODE":
                return ProfileArea.CODE;
            case "PROFILE_AREA_DISCUSSION":
                return ProfileArea.DISCUSSION;
            case "PROFILE_AREA_DATASETS":
                return ProfileArea.DATASETS;
            case "PROFILE_AREA_ACCOUNT":
                return ProfileArea.ACCOUNT;
            case "PROFILE_AREA_CONTACT":
                return ProfileArea.CONTACT;
            case "PROFILE_AREA_FOLLOWERS":
                return ProfileArea.FOLLOWERS;
            case "PROFILE_AREA_FOLLOWING":
                return ProfileArea.FOLLOWING;
            case "PROFILE_AREA_GENIE":
                return ProfileArea.GENIE;
            case "PROFILE_AREA_NOTIFICATIONS":
                return ProfileArea.NOTIFICATIONS;
            case "PROFILE_AREA_NOTEBOOKS":
                return ProfileArea.NOTEBOOKS;
        }
    }
};
export var RecentlyViewedItemType;
(function(RecentlyViewedItemType) {
    RecentlyViewedItemType["UNSPECIFIED"] = "unspecified";
    RecentlyViewedItemType["COMPETITION"] = "competition";
    RecentlyViewedItemType["DATASET"] = "dataset";
    RecentlyViewedItemType["KERNEL"] = "kernel";
    RecentlyViewedItemType["TOPIC"] = "topic";
    RecentlyViewedItemType["COURSE"] = "course";
    RecentlyViewedItemType["FORUM"] = "forum";
    RecentlyViewedItemType["CMS_PAGE"] = "cmsPage";
    RecentlyViewedItemType["MODEL"] = "model";
})(RecentlyViewedItemType || (RecentlyViewedItemType = {}));
export var RecentlyViewedItemTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RECENTLY_VIEWED_ITEM_TYPE_UNSPECIFIED":
            default:
                return RecentlyViewedItemType.UNSPECIFIED;
            case "COMPETITION":
                return RecentlyViewedItemType.COMPETITION;
            case "DATASET":
                return RecentlyViewedItemType.DATASET;
            case "KERNEL":
                return RecentlyViewedItemType.KERNEL;
            case "TOPIC":
                return RecentlyViewedItemType.TOPIC;
            case "COURSE":
                return RecentlyViewedItemType.COURSE;
            case "FORUM":
                return RecentlyViewedItemType.FORUM;
            case "CMS_PAGE":
                return RecentlyViewedItemType.CMS_PAGE;
            case "MODEL":
                return RecentlyViewedItemType.MODEL;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case RecentlyViewedItemType.UNSPECIFIED:
            case 0:
            default:
                return "RECENTLY_VIEWED_ITEM_TYPE_UNSPECIFIED";
            case RecentlyViewedItemType.COMPETITION:
            case 1:
                return "COMPETITION";
            case RecentlyViewedItemType.DATASET:
            case 2:
                return "DATASET";
            case RecentlyViewedItemType.KERNEL:
            case 4:
                return "KERNEL";
            case RecentlyViewedItemType.TOPIC:
            case 5:
                return "TOPIC";
            case RecentlyViewedItemType.COURSE:
            case 6:
                return "COURSE";
            case RecentlyViewedItemType.FORUM:
            case 7:
                return "FORUM";
            case RecentlyViewedItemType.CMS_PAGE:
            case 8:
                return "CMS_PAGE";
            case RecentlyViewedItemType.MODEL:
            case 9:
                return "MODEL";
        }
    }
};
export var RegistrationInfoFields;
(function(RegistrationInfoFields) {
    RegistrationInfoFields["UNSPECIFIED"] = "unspecified";
    RegistrationInfoFields["USER_NAME"] = "userName";
    RegistrationInfoFields["DISPLAY_NAME"] = "displayName";
    RegistrationInfoFields["EMAIL"] = "email";
    RegistrationInfoFields["PASSWORD"] = "password";
    RegistrationInfoFields["CAPTCHA"] = "captcha";
})(RegistrationInfoFields || (RegistrationInfoFields = {}));
export var RegistrationInfoFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "REGISTRATION_INFO_FIELDS_UNSPECIFIED":
            default:
                return RegistrationInfoFields.UNSPECIFIED;
            case "REGISTRATION_INFO_FIELDS_USER_NAME":
                return RegistrationInfoFields.USER_NAME;
            case "REGISTRATION_INFO_FIELDS_DISPLAY_NAME":
                return RegistrationInfoFields.DISPLAY_NAME;
            case "REGISTRATION_INFO_FIELDS_EMAIL":
                return RegistrationInfoFields.EMAIL;
            case "REGISTRATION_INFO_FIELDS_PASSWORD":
                return RegistrationInfoFields.PASSWORD;
            case "REGISTRATION_INFO_FIELDS_CAPTCHA":
                return RegistrationInfoFields.CAPTCHA;
        }
    }
};
export var ReportReason;
(function(ReportReason) {
    ReportReason["UNSPECIFIED"] = "unspecified";
    ReportReason["OTHER"] = "other";
    ReportReason["SPAM"] = "spam";
    ReportReason["PLAGIARISM"] = "plagiarism";
    ReportReason["VOTE_MANIPULATION"] = "voteManipulation";
    ReportReason["ABUSIVE"] = "abusive";
    ReportReason["PRIVACY_VIOLATION"] = "privacyViolation";
    ReportReason["COPYRIGHT_VIOLATION"] = "copyrightViolation";
    ReportReason["UPVOTE_BEGGING"] = "upvoteBegging";
    ReportReason["USER_DISPLAY_NAME"] = "userDisplayName";
    ReportReason["BIO"] = "bio";
    ReportReason["LLM"] = "llm";
    ReportReason[// Used on the FE to provide a dead-end option for broken notebook reports
    "NOT_REPORTABLE"] = "notReportable";
})(ReportReason || (ReportReason = {}));
export var ReportReasonWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ReportReason.UNSPECIFIED:
            case 0:
            default:
                return "REPORT_REASON_UNSPECIFIED";
            case ReportReason.OTHER:
            case 1:
                return "OTHER";
            case ReportReason.SPAM:
            case 2:
                return "SPAM";
            case ReportReason.PLAGIARISM:
            case 3:
                return "PLAGIARISM";
            case ReportReason.VOTE_MANIPULATION:
            case 4:
                return "VOTE_MANIPULATION";
            case ReportReason.ABUSIVE:
            case 5:
                return "ABUSIVE";
            case ReportReason.PRIVACY_VIOLATION:
            case 6:
                return "PRIVACY_VIOLATION";
            case ReportReason.COPYRIGHT_VIOLATION:
            case 7:
                return "COPYRIGHT_VIOLATION";
            case ReportReason.UPVOTE_BEGGING:
            case 8:
                return "UPVOTE_BEGGING";
            case ReportReason.USER_DISPLAY_NAME:
            case 9:
                return "USER_DISPLAY_NAME";
            case ReportReason.BIO:
            case 10:
                return "BIO";
            case ReportReason.LLM:
            case 11:
                return "LLM";
            case ReportReason.NOT_REPORTABLE:
            case 12:
                return "NOT_REPORTABLE";
        }
    }
};
export var ReturnedItemsType;
(function(ReturnedItemsType) {
    ReturnedItemsType["UNSPECIFIED"] = "unspecified";
    ReturnedItemsType["EDITED"] = "edited";
    ReturnedItemsType["VIEWED"] = "viewed";
    ReturnedItemsType["ALL"] = "all";
})(ReturnedItemsType || (ReturnedItemsType = {}));
export var ReturnedItemsTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ReturnedItemsType.UNSPECIFIED:
            case 0:
            default:
                return "RETURNED_ITEMS_TYPE_UNSPECIFIED";
            case ReturnedItemsType.EDITED:
            case 1:
                return "EDITED";
            case ReturnedItemsType.VIEWED:
            case 2:
                return "VIEWED";
            case ReturnedItemsType.ALL:
            case 3:
                return "ALL";
        }
    }
};
export var StartMigrateSsoOutcome;
(function(StartMigrateSsoOutcome) {
    StartMigrateSsoOutcome["GOOGLE_SSO_EXISTS"] = "googleSsoExists";
    StartMigrateSsoOutcome["EMAIL_LOGIN_EXISTS"] = "emailLoginExists";
    StartMigrateSsoOutcome["CREATE_PASSWORD"] = "createPassword";
})(StartMigrateSsoOutcome || (StartMigrateSsoOutcome = {}));
export var StartMigrateSsoOutcomeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "GOOGLE_SSO_EXISTS":
            default:
                return StartMigrateSsoOutcome.GOOGLE_SSO_EXISTS;
            case "EMAIL_LOGIN_EXISTS":
                return StartMigrateSsoOutcome.EMAIL_LOGIN_EXISTS;
            case "CREATE_PASSWORD":
                return StartMigrateSsoOutcome.CREATE_PASSWORD;
        }
    }
};
export var SurveyType;
(function(SurveyType) {
    SurveyType["UNSPECIFIED"] = "unspecified";
    SurveyType["HATS"] = "hats";
    SurveyType["DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY"] = "dataScienceAndMachineLearningSurvey";
    SurveyType["GOOGLE_CLOUD_ML_SUMMIT_2021"] = "googleCloudMlSummit2021";
})(SurveyType || (SurveyType = {}));
export var SurveyTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SURVEY_TYPE_UNSPECIFIED":
            default:
                return SurveyType.UNSPECIFIED;
            case "SURVEY_TYPE_HATS":
                return SurveyType.HATS;
            case "SURVEY_TYPE_DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY":
                return SurveyType.DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY;
            case "SURVEY_TYPE_GOOGLE_CLOUD_ML_SUMMIT_2021":
                return SurveyType.GOOGLE_CLOUD_ML_SUMMIT_2021;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SurveyType.UNSPECIFIED:
            case 0:
            default:
                return "SURVEY_TYPE_UNSPECIFIED";
            case SurveyType.HATS:
            case 1:
                return "SURVEY_TYPE_HATS";
            case SurveyType.DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY:
            case 2:
                return "SURVEY_TYPE_DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY";
            case SurveyType.GOOGLE_CLOUD_ML_SUMMIT_2021:
            case 3:
                return "SURVEY_TYPE_GOOGLE_CLOUD_ML_SUMMIT_2021";
        }
    }
};
export var TakeoutType;
(function(TakeoutType) {
    TakeoutType["UNSPECIFIED"] = "unspecified";
    TakeoutType["IDMEC_PRE_SOFT_DELETE"] = "idmecPreSoftDelete";
    TakeoutType["IDMEC_POST_SOFT_DELETE"] = "idmecPostSoftDelete";
    TakeoutType["USER_TAKEOUT"] = "userTakeout";
})(TakeoutType || (TakeoutType = {}));
export var TakeoutTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TakeoutType.UNSPECIFIED:
            case 0:
            default:
                return "TAKEOUT_TYPE_UNSPECIFIED";
            case TakeoutType.IDMEC_PRE_SOFT_DELETE:
            case 1:
                return "IDMEC_PRE_SOFT_DELETE";
            case TakeoutType.IDMEC_POST_SOFT_DELETE:
            case 3:
                return "IDMEC_POST_SOFT_DELETE";
            case TakeoutType.USER_TAKEOUT:
            case 2:
                return "USER_TAKEOUT";
        }
    }
};
export var UserAchievementTier;
(function(UserAchievementTier) {
    UserAchievementTier["NOVICE"] = "novice";
    UserAchievementTier["CONTRIBUTOR"] = "contributor";
    UserAchievementTier["EXPERT"] = "expert";
    UserAchievementTier["MASTER"] = "master";
    UserAchievementTier["GRANDMASTER"] = "grandmaster";
    UserAchievementTier[// Kaggle admins
    "STAFF"] = "staff";
    UserAchievementTier[// Flag user for tier recalculation
    "RECALC"] = "recalc";
})(UserAchievementTier || (UserAchievementTier = {}));
export var UserAchievementTierWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOVICE":
            default:
                return UserAchievementTier.NOVICE;
            case "CONTRIBUTOR":
                return UserAchievementTier.CONTRIBUTOR;
            case "EXPERT":
                return UserAchievementTier.EXPERT;
            case "MASTER":
                return UserAchievementTier.MASTER;
            case "GRANDMASTER":
                return UserAchievementTier.GRANDMASTER;
            case "STAFF":
                return UserAchievementTier.STAFF;
            case "RECALC":
                return UserAchievementTier.RECALC;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UserAchievementTier.NOVICE:
            case 0:
            default:
                return "NOVICE";
            case UserAchievementTier.CONTRIBUTOR:
            case 1:
                return "CONTRIBUTOR";
            case UserAchievementTier.EXPERT:
            case 2:
                return "EXPERT";
            case UserAchievementTier.MASTER:
            case 3:
                return "MASTER";
            case UserAchievementTier.GRANDMASTER:
            case 4:
                return "GRANDMASTER";
            case UserAchievementTier.STAFF:
            case 5:
                return "STAFF";
            case UserAchievementTier.RECALC:
            case 21:
                return "RECALC";
        }
    }
};
export var UserAchievementType;
(function(UserAchievementType) {
    UserAchievementType["UNSPECIFIED"] = "unspecified";
    UserAchievementType["COMPETITIONS"] = "competitions";
    UserAchievementType["NOTEBOOKS"] = "notebooks";
    UserAchievementType["DISCUSSION"] = "discussion";
    UserAchievementType["DATASETS"] = "datasets";
})(UserAchievementType || (UserAchievementType = {}));
export var UserAchievementTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "USER_ACHIEVEMENT_TYPE_UNSPECIFIED":
            default:
                return UserAchievementType.UNSPECIFIED;
            case "USER_ACHIEVEMENT_TYPE_COMPETITIONS":
                return UserAchievementType.COMPETITIONS;
            case "USER_ACHIEVEMENT_TYPE_NOTEBOOKS":
                return UserAchievementType.NOTEBOOKS;
            case "USER_ACHIEVEMENT_TYPE_DISCUSSION":
                return UserAchievementType.DISCUSSION;
            case "USER_ACHIEVEMENT_TYPE_DATASETS":
                return UserAchievementType.DATASETS;
        }
    }
};
export var ValidateResetPasswordCodeOutcome;
(function(ValidateResetPasswordCodeOutcome) {
    ValidateResetPasswordCodeOutcome["UNSPECIFIED"] = "unspecified";
    ValidateResetPasswordCodeOutcome[// Code was not valid.
    "INVALID_CODE"] = "invalidCode";
    ValidateResetPasswordCodeOutcome[// Code was valid, but the user is banned.
    "USER_BANNED"] = "userBanned";
    ValidateResetPasswordCodeOutcome[// No problems.
    "SUCCESS"] = "success";
    ValidateResetPasswordCodeOutcome[// No problems, but the user also has a google login they could use.
    "SUCCESS_USER_HAS_GOOGLE_LOGIN"] = "successUserHasGoogleLogin";
})(ValidateResetPasswordCodeOutcome || (ValidateResetPasswordCodeOutcome = {}));
export var ValidateResetPasswordCodeOutcomeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "VALIDATE_RESET_PASSWORD_CODE_OUTCOME_UNSPECIFIED":
            default:
                return ValidateResetPasswordCodeOutcome.UNSPECIFIED;
            case "VALIDATE_RESET_PASSWORD_CODE_OUTCOME_INVALID_CODE":
                return ValidateResetPasswordCodeOutcome.INVALID_CODE;
            case "VALIDATE_RESET_PASSWORD_CODE_OUTCOME_USER_BANNED":
                return ValidateResetPasswordCodeOutcome.USER_BANNED;
            case "VALIDATE_RESET_PASSWORD_CODE_OUTCOME_SUCCESS":
                return ValidateResetPasswordCodeOutcome.SUCCESS;
            case "VALIDATE_RESET_PASSWORD_CODE_OUTCOME_SUCCESS_USER_HAS_GOOGLE_LOGIN":
                return ValidateResetPasswordCodeOutcome.SUCCESS_USER_HAS_GOOGLE_LOGIN;
        }
    }
};
// These RPCs are implemented in Kaggle.Services.Legacy due to dependency
// issues:
// Service for nudges (pop-up dismissible prompts to the user)
// Currently only used for Employer/Organization Info nudges, but extensible to
// others
export var usersClient = {
    accountService: {
        contactSupport: createClient(ContactSupportRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/ContactSupport"),
        // Delete the current user's account (put into soft-delete, for later hard
        // delete).
        deleteCurrentAccount: createClient(DeleteCurrentAccountRequestWireFormat3, SoftDeleteAccountResponseWireFormat3, "users.AccountService/DeleteCurrentAccount"),
        expireApiTokens: createClient(ExpireApiTokensRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/ExpireApiTokens"),
        generateAnalyticsToken: createClient(GenerateAnalyticsTokenRequestWireFormat3, GenerateAnalyticsTokenResponseWireFormat3, "users.AccountService/GenerateAnalyticsToken"),
        generateApiToken: createClient(GenerateApiTokenRequestWireFormat3, GenerateApiTokenResponseWireFormat3, "users.AccountService/GenerateApiToken"),
        getBuildInfo: createClient(GetBuildInfoRequestWireFormat3, GetBuildInfoResponseWireFormat3, "users.AccountService/GetBuildInfo"),
        getSupportPhoneNumbers: createClient(GetSupportPhoneNumbersRequestWireFormat3, GetSupportPhoneNumbersResponseWireFormat3, "users.AccountService/GetSupportPhoneNumbers"),
        // List all user-visible penalties & data for the current user
        listCurrentUserPenaltyHistory: createClient(ListCurrentUserPenaltyHistoryRequestWireFormat3, ListCurrentUserPenaltyHistoryResponseWireFormat3, "users.AccountService/ListCurrentUserPenaltyHistory"),
        // Registers the user via email.
        newEmailRegistrationUser: createClient(NewEmailRegistrationUserRequestWireFormat3, NewEmailRegistrationUserResponseWireFormat3, "users.AccountService/NewEmailRegistrationUser"),
        // Validates registration values and returns any applicable errors.
        registrationValidation: createClient(RegistrationValidationRequestWireFormat3, RegistrationValidationResponseWireFormat3, "users.AccountService/RegistrationValidation"),
        // Report content for abuse, queuing it for the moderation team via Zendesk
        reportContent: createClient(ReportContentRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/ReportContent"),
        resendVerificationEmail: createClient(ResendVerificationEmailRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/ResendVerificationEmail"),
        // Given a valid password reset code, reset the password of the user to the
        // given password and log them in.
        resetPassword: createClient(ResetPasswordRequestWireFormat3, ResetPasswordResponseWireFormat3, "users.AccountService/ResetPassword"),
        // Sign the current user out.
        signOut: createClient(SignOutRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/SignOut"),
        // Delete the requested user's account (put into soft-delete, for late hard
        // delete).
        softDeleteAccount: createClient(SoftDeleteAccountRequestWireFormat3, SoftDeleteAccountResponseWireFormat3, "users.AccountService/SoftDeleteAccount"),
        startMigrateSso: createClient(StartMigrateSsoRequestWireFormat3, StartMigrateSsoResponseWireFormat3, "users.AccountService/StartMigrateSso"),
        // Creates and starts the phone verification process.
        // It uses the same request/response that for CreatePhoneVerificationCode
        // which is a subset of the process.
        // TODO: After the FE migrates from calling CreatePhoneVerificationCode,
        // rename these request/response.
        startPhoneVerification: createClient(StartPhoneVerificationRequestWireFormat3, StartPhoneVerificationResponseWireFormat3, "users.AccountService/StartPhoneVerification"),
        // Request a reset password code be sent to the given email. No direct
        // response to prevent leaking email existence.
        startResetPassword: createClient(StartResetPasswordRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/StartResetPassword"),
        // Performs user takeout, putting a user's data into the appropriate bucket.
        takeoutUser: createClient(TakeoutUserRequestWireFormat3, TakeoutUserResponseWireFormat3, "users.AccountService/TakeoutUser"),
        // Validate a given password code, and get the user Id for it if valid.
        validateResetPasswordCode: createClient(ValidateResetPasswordCodeRequestWireFormat3, ValidateResetPasswordCodeResponseWireFormat3, "users.AccountService/ValidateResetPasswordCode"),
        // Attempt to verify an account from an emailed verification code.
        verifyAccountEmail: createClient(VerifyAccountEmailRequestWireFormat3, VerifyAccountEmailResponseWireFormat3, "users.AccountService/VerifyAccountEmail"),
        verifyPhone: createClient(VerifyPhoneRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.AccountService/VerifyPhone"),
        // Verifies that the provided code matches the code for the current user.
        verifyPhoneVerificationCode: createClient(VerifyPhoneVerificationCodeRequestWireFormat3, VerifyPhoneVerificationCodeResponseWireFormat3, "users.AccountService/VerifyPhoneVerificationCode")
    },
    bookmarkService: {
        // Create bookmark entities of a given type from the current user's historical
        // Favorites
        convertLegacyFavorites: createClient(ConvertLegacyFavoritesRequestWireFormat3, ConvertLegacyFavoritesResponseWireFormat3, "users.BookmarkService/ConvertLegacyFavorites"),
        // Create bookmark of a given type from an entity ID for the current user
        createBookmark: createClient(CreateBookmarkRequestWireFormat3, CreateBookmarkResponseWireFormat3, "users.BookmarkService/CreateBookmark"),
        // Delete bookmark using bookmark_id, referring to the Bookmark entity for
        // current user
        deleteBookmark: createClient(DeleteBookmarkRequestWireFormat3, DeleteBookmarkResponseWireFormat3, "users.BookmarkService/DeleteBookmark"),
        // Create bookmark entities of a given type from the current user's historical
        // Favorites
        getBookmarkMigrationStatus: createClient(GetBookmarkMigrationStatusRequestWireFormat3, GetBookmarkMigrationStatusResponseWireFormat3, "users.BookmarkService/GetBookmarkMigrationStatus"),
        // List all bookmarks for the current user, publicly visible
        listAllBookmarks: createClient(ListAllBookmarksRequestWireFormat3, ListAllBookmarksResponseWireFormat3, "users.BookmarkService/ListAllBookmarks")
    },
    captchaService: {
        getCaptchaConfig: createClient(GetCaptchaConfigRequestWireFormat3, GetCaptchaConfigResponseWireFormat3, "users.CaptchaService/GetCaptchaConfig"),
        verifyCaptcha: createClient(VerifyCaptchaRequestWireFormat3, VerifyCaptchaResponseWireFormat3, "users.CaptchaService/VerifyCaptcha")
    },
    discordService: {
        // Delete the discord information related to a user, unlinking the accounts.
        deleteDiscordInfo: createClient(DeleteDiscordInfoRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.DiscordService/DeleteDiscordInfo"),
        // Get the discord information related to a user (if any).
        getDiscordInfo: createClient(GetDiscordInfoRequestWireFormat3, GetDiscordInfoResponseWireFormat3, "users.DiscordService/GetDiscordInfo"),
        // Syncs a user to discord, e.g. grant roles and change nickname.
        syncDiscordUser: createClient(SyncDiscordUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.DiscordService/SyncDiscordUser"),
        updateDiscordConfigValue: createClient(UpdateDiscordConfigValueRequestWireFormat3, DiscordConfigValueWireFormat3, "users.DiscordService/UpdateDiscordConfigValue")
    },
    genieService: {
        // Set the KaggleX mentor/mentee role for a group of users.
        bulkSetKaggleXRole: createClient(BulkSetKaggleXRoleRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.GenieService/BulkSetKaggleXRole"),
        // Verify a group of phone numbers.
        bulkVerifyPhone: createClient(BulkVerifyPhoneRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.GenieService/BulkVerifyPhone"),
        // Force-create a Kaggle login (username+password login).
        createKaggleAccount: createClient(CreateKaggleAccountRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.GenieService/CreateKaggleAccount"),
        // Get a new randomly generated password.
        getNewPassword: createClient(GetNewPasswordRequestWireFormat3, GetNewPasswordResponseWireFormat3, "users.GenieService/GetNewPassword"),
        // Fetches a user ID by a given username or email. Prioritizes username
        // matches.
        getUserIdByUsernameOrEmail: createClient(GetUserIdByUsernameOrEmailRequestWireFormat3, GetUserIdByUsernameOrEmailResponseWireFormat3, "users.GenieService/GetUserIdByUsernameOrEmail"),
        // Get the user status logs for a user.
        getUserStatusLogs: createClient(GetUserStatusLogsRequestWireFormat3, GetUserStatusLogsResponseWireFormat3, "users.GenieService/GetUserStatusLogs"),
        // Remove the admin privileges for a user.
        revokeSiteAdmin: createClient(RevokeSiteAdminRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.GenieService/RevokeSiteAdmin"),
        // Unverify a user's phone number, forcing them to reverify.
        unverifyPhone: createClient(UnverifyPhoneRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.GenieService/UnverifyPhone")
    },
    hatsService: {
        dismissHats: createClient(DismissHatsRequestWireFormat3, DismissHatsResponseWireFormat3, "users.HatsService/DismissHats"),
        dismissSurvey: createClient(DismissSurveyRequestWireFormat3, DismissSurveyResponseWireFormat3, "users.HatsService/DismissSurvey"),
        getUserHatsStatus: createClient(GetUserHatsStatusRequestWireFormat3, GetUserHatsStatusResponseWireFormat3, "users.HatsService/GetUserHatsStatus")
    },
    homePageService: {
        // Create a new placeholder suggested item (admin-only route).
        addSuggestedItem: createClient(AddSuggestedItemRequestWireFormat3, AddSuggestedItemResponseWireFormat3, "users.HomePageService/AddSuggestedItem"),
        // Mark a suggested item as dismissed, will put it at the bottom of the list
        // and stop showing for today.
        dismissSuggestedItem: createClient(DismissSuggestedItemRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.HomePageService/DismissSuggestedItem"),
        // Get all the stats that appear on the homepage for the current logged in
        // user.
        getHomePageStats: createClient(GetHomePageStatsRequestWireFormat3, GetHomePageStatsResponseWireFormat3, "users.HomePageService/GetHomePageStats"),
        // Returns all the numerical and listing data required to render the
        // logged-out homepage.
        getLoggedOutHomepageData: createClient(GetLoggedOutHomepageDataRequestWireFormat3, GetLoggedOutHomepageDataResponseWireFormat3, "users.HomePageService/GetLoggedOutHomepageData"),
        // Get all the data associated with showing the "Next Steps" section on the
        // homepage.
        getNextSteps: createClient(GetNextStepsRequestWireFormat3, GetNextStepsResponseWireFormat3, "users.HomePageService/GetNextSteps"),
        // Get all the data needed to configure next steps (admin-only route).
        getNextStepsConfig: createClient(GetNextStepsConfigRequestWireFormat3, GetNextStepsConfigResponseWireFormat3, "users.HomePageService/GetNextStepsConfig")
    },
    legacyOrganizationsService: {
        // Fetches organizations for the current user
        getOrganizations: createClient(GetOrganizationsRequestWireFormat3, GetOrganizationsResponseWireFormat3, "users.LegacyOrganizationsService/GetOrganizations")
    },
    legacyUsersService: {
        emailSignIn: createClient(EmailSignInRequestWireFormat3, EmailSignInResponseWireFormat3, "users.LegacyUsersService/EmailSignIn"),
        legacyChangePassword: createClient(LegacyChangePasswordRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.LegacyUsersService/LegacyChangePassword"),
        legacyDeleteUserLogin: createClient(LegacyDeleteUserLoginRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.LegacyUsersService/LegacyDeleteUserLogin"),
        legacyGetAccount: createClient(LegacyGetAccountRequestWireFormat3, AccountDtoWireFormat3, "users.LegacyUsersService/LegacyGetAccount"),
        legacyUpdateAccountEmailAddress: createClient(LegacyUpdateAccountEmailAddressRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.LegacyUsersService/LegacyUpdateAccountEmailAddress")
    },
    nudgeService: {
        addNudge: createClient(AddNudgeRequestWireFormat3, AddNudgeResponseWireFormat3, "users.NudgeService/AddNudge"),
        // Check if a user should be served a particular custom nudge.
        checkCustomNudge: createClient(CheckCustomNudgeRequestWireFormat3, CheckCustomNudgeResponseWireFormat3, "users.NudgeService/CheckCustomNudge"),
        // Check if a user has any available nudges to show
        checkForNudge: createClient(CheckForNudgeRequestWireFormat3, CheckForNudgeResponseWireFormat3, "users.NudgeService/CheckForNudge"),
        getNudgeConfig: createClient(GetNudgeConfigRequestWireFormat3, GetNudgeConfigResponseWireFormat3, "users.NudgeService/GetNudgeConfig"),
        // Log what a user did with the nudge (ie did they ignore? accept?)
        reactToNudge: createClient(ReactToNudgeRequestWireFormat3, ReactToNudgeResponseWireFormat3, "users.NudgeService/ReactToNudge"),
        // Report that a user is seeing a particular nudge
        // This should only be called once by the frontend for a particular user/nudge
        // pair
        showingNudge: createClient(ShowingNudgeRequestWireFormat3, ShowingNudgeResponseWireFormat3, "users.NudgeService/ShowingNudge")
    },
    profileService: {
        // Gets a user's public profile information
        getProfile: createClient(GetProfileRequestWireFormat3, GetProfileResponseWireFormat3, "users.ProfileService/GetProfile"),
        // Fetches information used for populating the profile preview feature.
        getProfilePreview: createClient(GetProfilePreviewRequestWireFormat3, GetProfilePreviewResponseWireFormat3, "users.ProfileService/GetProfilePreview"),
        // Returns activity information for each day to populate a user's activity
        // graph
        getUserActivity: createClient(GetUserActivityRequestWireFormat3, GetUserActivityResponseWireFormat3, "users.ProfileService/GetUserActivity"),
        // Returns total counts of different user discussions engagement, e.g. created
        // topics, replies, etc.
        getUserDiscussionCounts: createClient(GetUserDiscussionCountsRequestWireFormat3, DiscussionCountsWireFormat3, "users.ProfileService/GetUserDiscussionCounts"),
        // Fetch discussion messages to display on a user's profile on the discussions
        // tab
        getUserDiscussionMessages: createClient(GetUserDiscussionMessagesRequestWireFormat3, GetUserDiscussionMessagesResponseWireFormat3, "users.ProfileService/GetUserDiscussionMessages"),
        // Updates a user bio, which is a short message about the user.
        updateBio: createClient(UpdateBioRequestWireFormat3, UpdateBioResponseWireFormat3, "users.ProfileService/UpdateBio"),
        // Updates various personal information/links about a user
        updateProfile: createClient(UpdateProfileRequestWireFormat3, UpdateProfileResponseWireFormat3, "users.ProfileService/UpdateProfile"),
        // Updates the user's main profile image.
        updateProfileImage: createClient(UpdateProfileImageRequestWireFormat3, UpdateProfileImageResponseWireFormat3, "users.ProfileService/UpdateProfileImage")
    },
    progressionService: {
        // Gets the progression tiers and current rankings for the current user
        getCurrentUserProgression: createClient(GetCurrentUserProgressionRequestWireFormat3, GetCurrentUserProgressionResponseWireFormat3, "users.ProgressionService/GetCurrentUserProgression"),
        getUserRankings: createClient(GetUserRankingsRequestWireFormat3, UserRankingsWireFormat3, "users.ProgressionService/GetUserRankings")
    },
    recentlyViewedService: {
        getRecentlyViewedItems: createClient(GetRecentlyViewedItemsRequestWireFormat3, GetRecentlyViewedItemsResponseWireFormat3, "users.RecentlyViewedService/GetRecentlyViewedItems")
    },
    usersService: {
        acceptCookies: createClient(AcceptCookiesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/AcceptCookies"),
        activateAccount: createClient(ActivateAccountRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/ActivateAccount"),
        // Send a message to the given user.
        createUserMessage: createClient(CreateUserMessageRequestWireFormat3, CreateUserMessageResponseWireFormat3, "users.UsersService/CreateUserMessage"),
        deletePhoneVerifications: createClient(DeletePhoneVerificationsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/DeletePhoneVerifications"),
        // Current user follows the requested user by username
        followUser: createClient(FollowUserRequestWireFormat3, FollowUserResponseWireFormat3, "users.UsersService/FollowUser"),
        // Get information about whether the current user can use the contact user
        // feature.
        getContactUserInfo: createClient(GetContactUserInfoRequestWireFormat3, GetContactUserInfoResponseWireFormat3, "users.UsersService/GetContactUserInfo"),
        // Get the current user, or null if no user is logged in. Note please avoid
        // using if you just need the Id.
        getCurrentUser: createClient(GetCurrentUserRequestWireFormat3, UserWireFormat3, "users.UsersService/GetCurrentUser"),
        // Get the id of the current user, or null if no user is logged in. No DB
        // access required.
        getCurrentUserId: createClient(GetCurrentUserIdRequestWireFormat3, GetCurrentUserIdResponseWireFormat3, "users.UsersService/GetCurrentUserId"),
        getHomepageStatsDismissedStatus: createClient(GetHomepageStatsDismissedStatusRequestWireFormat3, GetHomepageStatsDismissedStatusResponseWireFormat3, "users.UsersService/GetHomepageStatsDismissedStatus"),
        getMyAttributes: createClient(GetMyAttributesRequestWireFormat3, GetMyAttributesResponseWireFormat3, "users.UsersService/GetMyAttributes"),
        getOnboardingDismissedStatus: createClient(GetOnboardingDismissedStatusRequestWireFormat3, GetOnboardingDismissedStatusResponseWireFormat3, "users.UsersService/GetOnboardingDismissedStatus"),
        getUploadWarningDismissedHandler: createClient(GetUploadWarningDismissedRequestWireFormat3, GetUploadWarningDismissedResponseWireFormat3, "users.UsersService/GetUploadWarningDismissedHandler"),
        // Fetch information about a given user. Note if this is a different user,
        // some fields won't be returned.
        getUser: createClient(GetUserRequestWireFormat3, UserWireFormat3, "users.UsersService/GetUser"),
        getUserCount: createClient(GetUserCountRequestWireFormat3, GetUserCountResponseWireFormat3, "users.UsersService/GetUserCount"),
        getUserEmojiSkinToneHandler: createClient(GetUserEmojiSkinToneRequestWireFormat3, GetUserEmojiSkinToneResponseWireFormat3, "users.UsersService/GetUserEmojiSkinToneHandler"),
        migrateTermsAcceptances: createClient(MigrateTermsAcceptancesRequestWireFormat3, MigrateTermsAcceptancesResponseWireFormat3, "users.UsersService/MigrateTermsAcceptances"),
        searchPlaces: createClient(SearchPlacesRequestWireFormat3, SearchPlacesResponseWireFormat3, "users.UsersService/SearchPlaces"),
        searchUsersSuggestions: createClient(SearchUsersSuggestionsRequestWireFormat3, SearchUsersSuggestionsResponseWireFormat3, "users.UsersService/SearchUsersSuggestions"),
        setMyAttributes: createClient(SetMyAttributesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/SetMyAttributes"),
        // For an admin to set a user's phone reputable.
        setPhoneReputable: createClient(SetPhoneReputableRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/SetPhoneReputable"),
        setUploadWarningDismissedHandler: createClient(SetUploadWarningDismissedRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/SetUploadWarningDismissedHandler"),
        // Current user unfollows the requested user by username
        unfollowUser: createClient(UnfollowUserRequestWireFormat3, UnfollowUserResponseWireFormat3, "users.UsersService/UnfollowUser"),
        unsubscribeNewsletter: createClient(UnsubscribeNewsletterRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/UnsubscribeNewsletter"),
        updateHomepageStatsDismissedStatus: createClient(UpdateHomepageStatsDismissedStatusRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/UpdateHomepageStatsDismissedStatus"),
        updateOnboardingDismissedStatus: createClient(UpdateOnboardingDismissedStatusRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/UpdateOnboardingDismissedStatus"),
        updateUserEmojiSkinToneHandler: createClient(UpdateUserEmojiSkinToneRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.UsersService/UpdateUserEmojiSkinToneHandler")
    },
    workspacesService: {
        // Creates a new workspace for the current user
        createWorkspace: createClient(CreateWorkspaceRequestWireFormat3, CreateWorkspaceResponseWireFormat3, "users.WorkspacesService/CreateWorkspace"),
        // Creates items inside an existing workspace created by the current user
        createWorkspaceItems: createClient(CreateWorkspaceItemsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.WorkspacesService/CreateWorkspaceItems"),
        // Deletes an existing workspace created by the current user
        deleteWorkspace: createClient(DeleteWorkspaceRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.WorkspacesService/DeleteWorkspace"),
        // Deletes items from an existing workspace created by the current user
        deleteWorkspaceItems: createClient(DeleteWorkspaceItemsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.WorkspacesService/DeleteWorkspaceItems"),
        // Returns a list of custom workspaces created by the current user
        listWorkspaces: createClient(ListWorkspacesRequestWireFormat3, ListWorkspacesResponseWireFormat3, "users.WorkspacesService/ListWorkspaces"),
        // Updates an existing workspace created by the current user
        updateWorkspace: createClient(UpdateWorkspaceRequestWireFormat3, google.protobuf.EmptyWireFormat3, "users.WorkspacesService/UpdateWorkspace")
    }
};
